import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Card, Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Row, Table } from 'reactstrap';

import styles from './style.module.scss';

import InfoIcon from '../../../assets/images/icons/info.svg';
import MoreIcon from '../../../assets/images/icons/more.svg';

import NoDataFound from '../../../components/Common/no-data-found/no-data-found';
import InitialMessage from '../../../components/Common/initial-message/initial-message';
import InvalidData from '../../../components/Common/invalid-data/invalid-data';
import ActionCard from '../../../components/Footer/ActionCard';
import UnsavedDataModal from '../../../components/Common/Modals/UnsavedDataModal';
import SuccessModal from '../../../components/Common/Modals/SuccessModal';
import Tooltip from '../../../components/Common/tooltip/tooltip';

import {
  calculateProductTotal,
  totalWeeksOfSelectedQuarter,
  calculateMeasureTotal,
  calculateQuarterTotalForEachMeasure,
  calculateWeekTotalForEachMeasure,
  calculateMeasureAverage,
  calculateQuarterValue,
  calculateWeekValue,
  calculateQuarterTotal,
  calculateEachProductTotal,
  calculateHorizontalWeekTotal,
  calculateVerticalWeekTotal,
  calculateCMQuarter,
  calculateCMQuarterTotalForEachMeasure,
  calculateCMProductTotalForEachMeasure,
  calculateCMProduct,
  calculateCMWeekTotalForEachMeasure, checkIfAllQuartersArePast,
  nonEditableWeekTotal,
} from './helper';
import {
  IsNegative,
  NumberWithCommas,
  TwoDecimalPlace,
  TwoDecimalPlaceHandler,
  GetPlanId, getRatioSelectionOfEditAllGrid, getRatioSelectionOfEditAllQuarterGrid, OneDecimalPlace,
  getRatioTotal, getRatioTotalForQuarter, sum, avg,
} from '../../../helpers/Helpers';
import { UpdateEditRestriction } from '../../../store/action-restriction/actions';

import { IEditAllData, IEditAllImportExcelPayload, IEditAllPayload } from '../../../interfaces/rolling-plan-edit-all.interface';
import { DownloadEditAllTemplate } from '../../../api-services/common.api';
import {
  GetEditAllData,
  FreezePlanEditAll,
  UpdateEditAllData,
  ImportTemplateEditAll
} from '../../../api-services/rolling-plan.api';

interface OwnProps {
  isCallRequired: boolean;
  onLoadEnd: () => void;
  onUpdateStart: () => void;
  onUpdateEnd: () => void;
  onRunningEnd: () => void;
}

interface StateProps {
  history: any;
  isAllowed: boolean;
  filterData: any;
}

interface DispatchProps {
  UpdateEditRestriction: (isAllowed: boolean) => void;
}

type Props = StateProps & DispatchProps & OwnProps;

interface State {
  isAutoLoad:boolean;
  isLoading: boolean;
  originalDataSource: any;
  dataSource: any;
  selectedColumn: string;
  comparisionMetricsList: {
    label: string;
    value: string;
  }[];
  isMoreMenuOpened: boolean;
  isDownloadMenu: boolean;
  comparisionMetrics: string;
  isEditRestrictionAllowed: boolean;
  isRunningModal: boolean;
  successMessage: string;
}

class EditAllTable extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      isAutoLoad:true,
      isLoading: true,
      originalDataSource: { columns: [], rows: [] },
      dataSource: { columns: [], rows: [] },
      selectedColumn: '',
      comparisionMetricsList: [
        { label: 'None', value: 'None' },
        { label: 'LY Actuals', value: 'ly' },
        { label: 'LQ Actuals', value: 'lq' }
      ],
      isMoreMenuOpened: false,
      isDownloadMenu: false,
      comparisionMetrics: 'None',
      isEditRestrictionAllowed: false,
      isRunningModal: false,
      successMessage: ''
    };
    this.toggleMoreMenu = this.toggleMoreMenu.bind(this);
    this.toggleDownloadMenu = this.toggleDownloadMenu.bind(this);
  }

  toggleMoreMenu(): void {
    this.setState((prevState) => ({
      isMoreMenuOpened: !prevState.isMoreMenuOpened
    }));
  }

  toggleDownloadMenu(): void {
    this.setState((prevState) => ({
      isDownloadMenu: !prevState.isDownloadMenu
    }));
  }

  componentDidMount(): void {
    const { state } = this.props.history.location;
    const fromRollingPlan = state?.fromRollingPlan ?? false;  // Read flag
    if (fromRollingPlan) {
        this.getEditAllData(); // Load data ONLY if coming from Rolling Plan
    } else {
        this.setState({ isLoading: false }); 
        this.props.onLoadEnd();
    }
  }

  componentDidUpdate(prevProps, prevState): void {
    if (!prevProps.isCallRequired && this.props.isCallRequired) {
      this.setState({
        isLoading: true
      }, () => {
        this.getEditAllData();
      });
    }
  }

  downloadEditAllTemplate(downloadType: string, type: string): void {
    this.setState({ isLoading: true });
    const params = {
      downloadType, type,
      planId: GetPlanId(this.props.history.location.pathname) || 1,
      userId: sessionStorage.getItem('userName')
    };

    DownloadEditAllTemplate(params).then((response) => {
      let filename = '';
      switch (type) {
        case 'SPEA':
          if (downloadType === 'units')
            filename = 'sales_plan_unit_edit_all.xlsx';
          else
            filename = 'sales_plan_revenue_edit_all.xlsx';
          break;
        case 'RSPEA':
          if (downloadType === 'units')
            filename = 'rolling_plan_unit_edit_all.xlsx';
          else
            filename = 'rolling_plan_revenue_edit_all.xlsx';
          break;
        case 'STPEA':
          if (downloadType === 'units')
            filename = 'strategic_plan_unit_edit_all.xlsx';
          else
            filename = 'strategic_plan_revenue_edit_all.xlsx';
          break;
      }
      response.blob().then(blob => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        this.setState({ isLoading: false });
      });
    });
  }

  importTemplateEditAll = (event): void => {
    let formData = new FormData();
    formData.append('file', event.target['files'][0], event.target['files'][0].name);
    
    //Start payload
      const importExcelPayload: IEditAllImportExcelPayload = {
        row: []
      };

      const rowMap = new Map<string, { name: string; products: { name: string; weeks: { name: string; value: number; ratioSelection: string }[]; }[]; }>();

    this.state.dataSource.rows.forEach((row) => {
      const rowName = row.displayName;

      const productList: {
        name: string;
        weeks: { name: string; value: number; ratioSelection: string }[];
      }[] = [];

      row.products
        .filter((product) => product.name !== 'Total' && product.name !== 'Average')
        .forEach((product) => {
          const allWeeks: { name: string; value: number; ratioSelection: string }[] = [];

          product.quarters.forEach((quarter) => {
            const weekLength = quarter.weeks.length;
            const isValidForecast = quarter.weeks[weekLength - 1]?.forecastVal > 0;

            const weeks = quarter.weeks
              .filter((week) => !week.isPast)
              .map((week) => ({
                name: week.name,
                value: week.value,
                ratioSelection: getRatioSelectionOfEditAllGrid(week, isValidForecast),
              }));

            allWeeks.push(...weeks);
          });

          productList.push({
            name: product.name,
            weeks: allWeeks,
          });
        });

      if (!rowMap.has(rowName)) {
        rowMap.set(rowName, { name: rowName, products: productList });
      } else {
        const existing = rowMap.get(rowName)!;
        existing.products.push(...productList);
      }
    });
    
  importExcelPayload.row = Array.from(rowMap.values());
    //End payload
      console.log(importExcelPayload);
      formData.append('payload', JSON.stringify(importExcelPayload));
    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname),
      type: 'RSPEA'
    };

    this.props.onUpdateStart();

    ImportTemplateEditAll(formData, params)
      .then(() => {
        this.setState({ isRunningModal: true,
                  successMessage: 'Your changes have been successfully saved and are now frozen.'
                 });
        this.props.onUpdateEnd();
      });
  };

  freezePlan(): void {
    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname)
    };

    this.props.onUpdateStart();

    FreezePlanEditAll(params)
      .then(() => {
        this.props.onUpdateEnd();
        this.props.UpdateEditRestriction(false);
        this.setState({ isRunningModal: true,
                        successMessage: 'Your changes have been successfully saved and are now frozen.'
                       });
      });
  }

  getEditAllData(): void {
    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname)
    };

    GetEditAllData(params)
      .then((res: IEditAllData) => {
        this.setState({
          originalDataSource: !!res ? res : { columns: [], rows: [] },
          isLoading: false,isAutoLoad: false,
        }, () => {
          if (this.validateJSON()) {
            this.dataInit(true);
          }
          this.props.onLoadEnd();
        });

        this.props.UpdateEditRestriction(false);
      });
  }

  dataInit(isNew: boolean): void {
    const data: IEditAllData = { ...this.state.originalDataSource };
    const dataSource: IEditAllData = {
      columns: data.columns.map((col) => {
        return {
          ...col,
          isExpanded: col.isExpanded,
        };
      }),
      rows: data.rows.map((measure, mIdx: number) => {
        const lyActualValues = measure.products.map(product => {
          const lyItem = product.LYLQ.find(item => item.name === "LY Actual");
          return lyItem ? Number(lyItem.value) : 0;
        });

        const yoyPctValues = measure.products.map(product => {
          const lyItem = product.LYLQ.find(item => item.name === "YOY %");
          return lyItem ? Number(lyItem.value) : 0;
        });

        if (isNew) {
          const lastRow = measure.products[0];
          measure.products.push(lastRow);
        }

        return {
          ...measure,
          products: measure.products.map((product, pIdx: number) => {
            const productTotal = measure.products.length - 1 === pIdx
              ? (
                ['Plan ASP', 'Margin %'].indexOf(measure.name) !== -1
                  ? calculateMeasureAverage(data.rows, measure.name)
                  : calculateMeasureTotal(data.rows[mIdx].products, measure.name)
              )
              : calculateProductTotal(data.rows, mIdx, pIdx, measure.name);

            return {
              ...product,
              name: measure.products.length - 1 === pIdx
                ? ['Plan ASP', 'Margin %'].indexOf(measure.name) !== -1 ? 'Average' : 'Total'
                : product.name,
              value: productTotal,
              oldVal: productTotal,
              isPast: checkIfAllQuartersArePast(product.quarters),
              ly: measure.products.length - 1 === pIdx
                ? calculateCMProductTotalForEachMeasure(data.rows, mIdx, pIdx, 'ly', measure.name)
                : calculateCMProduct(data.rows, mIdx, pIdx, 'ly'),
              lq: measure.products.length - 1 === pIdx
                ? calculateCMProductTotalForEachMeasure(data.rows, mIdx, pIdx, 'lq', measure.name)
                : calculateCMProduct(data.rows, mIdx, pIdx, 'lq'),
              LYLQ: product.LYLQ.map((lylq) => {
                let computedValue = lylq.value;

                switch (measure.name) {
                  case "Plan / Quota - UNITS":
                    if (lylq.name === "LY Actual") computedValue = sum(lyActualValues);
                    if (lylq.name === "YOY %") computedValue = ((productTotal - sum(lyActualValues)) /sum(lyActualValues))*100;
                    break;
                  case "Plan / Quota - $":
                  case "Margin $":
                    if (lylq.name === "LY Actual") computedValue = sum(lyActualValues);
                    if (lylq.name === "YOY %") computedValue = avg(yoyPctValues);
                    break;

                  case "Plan ASP":
                  case "Margin %":
                    if (lylq.name === "LY Actual") computedValue = avg(lyActualValues);
                    if (lylq.name === "YOY %") computedValue = avg(yoyPctValues);
                    break;

                  default:
                    computedValue = lylq.value; // fallback
                }

                return {
                  ...lylq,
                  value: measure.products.length - 1 === pIdx ? TwoDecimalPlace(computedValue) : TwoDecimalPlace(lylq.value),
                  oldVal: measure.products.length - 1 === pIdx ? TwoDecimalPlace(computedValue) : TwoDecimalPlace(lylq.value)
                };
              }),
              quarters: product.quarters.map((quarter, qIdx: number) => {
                const quarterTotal = measure.products.length - 1 === pIdx
                  ? calculateQuarterTotalForEachMeasure(data.rows, mIdx, pIdx, qIdx, measure.name)
                  : calculateQuarterValue(data.rows, mIdx, pIdx, qIdx, measure.name);

                return {
                  ...quarter,
                  isExpanded: data.columns[qIdx + 2].isExpanded,
                  isEdited: false,
                  isChanged: false,
                  isDisabled: false,
                  value: quarterTotal,
                  oldVal: quarterTotal,
                  ly: measure.products.length - 1 === pIdx
                    ? calculateCMQuarterTotalForEachMeasure(data.rows, mIdx, qIdx, 'ly', measure.name)
                    : calculateCMQuarter(quarter.weeks, 'ly'),
                  lq: measure.products.length - 1 === pIdx
                    ? calculateCMQuarterTotalForEachMeasure(data.rows, mIdx, qIdx, 'lq', measure.name)
                    : calculateCMQuarter(quarter.weeks, 'lq'),
                  weeks: quarter.weeks.map((week, wIdx: number) => {
                    const weekTotal = measure.products.length - 1 === pIdx
                      ? calculateWeekTotalForEachMeasure(data.rows, mIdx, pIdx, qIdx, wIdx, measure.name)
                      : calculateWeekValue(data.rows, mIdx, pIdx, qIdx, wIdx, measure.name);

                    return {
                      ...week,
                      isChanged: false,
                      isDisabled: false,
                      value: weekTotal,
                      oldVal: weekTotal,
                      ly: measure.products.length - 1 === pIdx
                        ? calculateCMWeekTotalForEachMeasure(data.rows, mIdx, qIdx, wIdx, 'ly', measure.name)
                        : TwoDecimalPlace(week.ly),
                      lq: measure.products.length - 1 === pIdx
                        ? calculateCMWeekTotalForEachMeasure(data.rows, mIdx, qIdx, wIdx, 'lq', measure.name)
                        : TwoDecimalPlace(week.lq)
                    };
                  })
                };
              })
            };
          })
        };
      })
    };

    this.setState({ dataSource });
  }

  validateJSON(): boolean {
    let valid = true;

    const quarterLength = this.state.originalDataSource.columns.filter((col) => col.months).length;
    valid = valid && this.state.originalDataSource.rows
      .reduce((rInit, row) => rInit && row.products
        .reduce((pInit, product) => pInit && product.quarters.length === quarterLength, true), true);

    const weekLength = this.state.originalDataSource.columns
      .filter((col) => col.months)
      .reduce((colInit, col) => {
        colInit += col.months.reduce((mInit, month) => {
          mInit += month.weeks.length;
          return mInit;
        }, 0);
        return colInit;
      }, 0);

    const check = this.state.originalDataSource.rows
      .reduce((rInit, row) => rInit && row.products
        .reduce((pInit, product) => {
          return pInit && product.quarters
            .reduce((qInit, quarter) => {
              qInit += quarter.weeks.length;
              return qInit;
            }, 0) === weekLength
        }, true), true);

    valid = valid && check;

    return valid;
  }

  onExpandColumn(colIdx: number, isExpanded: boolean): void {
    const columns = [...this.state.dataSource.columns];
    columns.map((col, index) => {
      col.isExpanded = (colIdx === index) ? !isExpanded : false;
      return col;
    });

    const rows = [...this.state.dataSource.rows];
    rows.forEach((row, rIdx: number) => {
      row.products.forEach((product, pIdx: number) => {
        columns
          .filter((col) => col.months)
          .map((col, index) => {
            const qIdx = product.quarters
              .findIndex((quarter) => quarter.name === columns.filter((col) => col.months)[index].name);
            if (qIdx > -1 && index === (colIdx - 2)) {
              rows[rIdx].products[pIdx].quarters[qIdx].isExpanded = !rows[rIdx].products[pIdx].quarters[qIdx].isExpanded;
            } else {
              rows[rIdx].products[pIdx].quarters[qIdx].isExpanded = false;
            }
          });
      });
    });

    this.setState({ dataSource: this.state.dataSource });
  }

  isColumnExpanded(): boolean {
    return this.state.dataSource.columns
      .filter((col) => col.months)
      .reduce((acc, col) => acc || col.isExpanded, false);
  }

  updateMeasureCalculation(
    rowArr,
    rowIdx: number,
    productIdx: number,
    measureGroup: string,
    productName: string,
    event
  ): void {
    const value: any = event.target.value !== '' ? parseFloat(TwoDecimalPlaceHandler(event.target.value)) : '';

    this.state.dataSource.rows[rowIdx].products[productIdx].value = value || 0;
    this.state.dataSource.rows[rowIdx].products[productIdx].isEdited = true;
    this.state.dataSource.rows[rowIdx].products[productIdx].isChanged = true;

    // Edit Controls
    const planArr = ['Plan / Quota - UNITS', 'Plan / Quota - $', 'Plan ASP'];
    const marginArr = ['Margin %', 'Margin $'];
    const check = planArr.indexOf(measureGroup) !== -1;

    const rowIndex = this.state.dataSource.rows
      .filter((row) => (check ? planArr : marginArr).indexOf(row.name) !== -1)
      .findIndex((row) => row.name === measureGroup);
    this.state.dataSource.rows
      .filter((row) => (check ? planArr : marginArr).indexOf(row.name) !== -1)
      .forEach((row, rIdx: number) => {
        row.products
          .forEach((product, pIdx) => {
            const condition = ['Total', 'Average'].indexOf(productName) === -1
              ? (rIdx !== rowIndex) && (pIdx === productIdx) || (row.products.length - 1 === pIdx)
              : (rIdx !== rowIndex) || (row.products.length - 1 !== pIdx);
            product.isDisabled = !product.isDisabled ? condition : product.isDisabled;
            product.quarters.forEach((quarter) => {
              quarter.isDisabled = !quarter.isDisabled ? condition : quarter.isDisabled;
            });
          });
      });

    const pastQuarterTotal = this.state.dataSource.rows[rowIdx].products[productIdx].quarters
      .filter((quarter) => quarter.isPast)
      .reduce((pastVal, quarter) => {
        pastVal += quarter.oldVal;
        return pastVal;
      }, 0);

    const editableQuarterTotal = this.state.dataSource.rows[rowIdx].products[productIdx].quarters
      .filter((quarter) => !quarter.isPast)
      .reduce((pastVal, quarter) => {
        pastVal += quarter.oldVal;
        return pastVal;
      }, 0);

    const remainingVal = value - pastQuarterTotal;

    if (measureGroup === 'Plan / Quota - UNITS' && productName !== 'Total') {
      /*Update quarters and measure total of Plan / Quota - UNITS*/
      const productDetails = this.state.dataSource.rows[rowIdx].products[productIdx];
      this.state.dataSource.rows[rowIdx].products[productIdx].quarters
        .filter((quarter) => !quarter.isPast)
        .forEach((quarter) => {
          quarter.value = productDetails.oldVal > 0
            ? Math.round((quarter.oldVal / editableQuarterTotal) * remainingVal)
            : 0;
          quarter.isChanged = true;
        });

      const totalIdx = this.state.dataSource.rows[rowIdx].products.findIndex((product) => product.name === 'Total');
      this.state.dataSource.rows[rowIdx].products[totalIdx].value =
        calculateMeasureTotal(this.state.dataSource.rows[rowIdx].products, measureGroup);
      this.state.dataSource.rows[rowIdx].products[totalIdx].quarters.forEach((quarter, qIdx: number) => {
        quarter.value = calculateQuarterTotal(this.state.dataSource.rows[rowIdx].products, qIdx, measureGroup);
      });

      const planAspIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan ASP');
      const planQuotaIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - $');
      const avgIdx = this.state.dataSource.rows[planAspIdx].products.findIndex((product) => product.name === 'Average');
      const planMarginIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Margin $');

      /*edit control for dependent measures*/
      const planValueIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - $');

      this.state.dataSource.rows[planAspIdx].products[productIdx].isDisabled = false;
      this.state.dataSource.rows[planValueIdx].products[productIdx].isDisabled = false;
      this.state.dataSource.rows[planMarginIdx].products[productIdx].isDisabled = false;

      this.state.dataSource.rows[rowIdx].products[productIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });
      this.state.dataSource.rows[planAspIdx].products[productIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });
      this.state.dataSource.rows[planValueIdx].products[productIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });
      this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });

      const isPlanAspEdited = this.state.dataSource.rows[planAspIdx].products[productIdx].isEdited;
      const isPlanValueEdited = this.state.dataSource.rows[planValueIdx].products[productIdx].isEdited;

      if (isPlanAspEdited) {
        /*Calculation of Plan Quota when UNIT and ASP are edited*/
        const planAspValue = this.state.dataSource.rows[planAspIdx].products[productIdx].value;
        this.state.dataSource.rows[planValueIdx].products[productIdx].value =
          TwoDecimalPlace(value * planAspValue);
        this.state.dataSource.rows[planValueIdx].products[productIdx].quarters
          .forEach((quarter, qIdx: number) => {
            const planUnitQuarterValue = this.state.dataSource.rows[rowIdx].products[productIdx].quarters[qIdx].value;
            const planAspQuarterValue = this.state.dataSource.rows[planAspIdx].products[productIdx].quarters[qIdx].value;
            quarter.value = TwoDecimalPlace(planUnitQuarterValue * planAspQuarterValue);
            quarter.isChanged = true;
          });

        /*Calculation of Plan Quota total when UNIT and ASP are edited*/
        const planUnitTotal = this.state.dataSource.rows[rowIdx].products[totalIdx].value;
        const planAspTotal = this.state.dataSource.rows[planAspIdx].products[avgIdx].value;

        this.state.dataSource.rows[planValueIdx].products[totalIdx].value =
          TwoDecimalPlace(planUnitTotal * planAspTotal);
        this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters.forEach((quarter, qIdx: number) => {
          quarter.value = calculateQuarterValue(rowArr, planValueIdx, totalIdx, qIdx, 'Plan / Quota - $');
        });

        this.state.dataSource.rows[planValueIdx].products[productIdx].isDisabled = true;
        this.state.dataSource.rows[planValueIdx].products[productIdx].quarters.forEach((quarter) => {
          quarter.isDisabled = true;
        });
      } else if (isPlanValueEdited) {
        /*Calculation of ASP when UNIT and Plan Quota are edited*/
        const planQuotaValue = this.state.dataSource.rows[planQuotaIdx].products[productIdx].value;
        this.state.dataSource.rows[planAspIdx].products[productIdx].value =
          value !== 0 ? TwoDecimalPlace(planQuotaValue / value) : 0;
        this.state.dataSource.rows[planAspIdx].products[productIdx].quarters.forEach((quarter, qIdx: number) => {
          quarter.value = calculateQuarterValue(rowArr, planAspIdx, productIdx, qIdx, 'Plan ASP');
        });

        /*Calculation of Plan Quota total when UNIT and Plan Quota are edited*/
        const planUnitTotal = this.state.dataSource.rows[rowIdx].products[totalIdx].value;
        const planValueTotal = this.state.dataSource.rows[planQuotaIdx].products[totalIdx].value;

        this.state.dataSource.rows[planAspIdx].products[avgIdx].value =
          planUnitTotal !== 0 ? TwoDecimalPlace(planValueTotal / planUnitTotal) : planUnitTotal;
        this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters.forEach((quarter, qIdx: number) => {
          quarter.value = calculateQuarterValue(rowArr, planAspIdx, avgIdx, qIdx, 'Plan ASP');
        });

        this.state.dataSource.rows[planAspIdx].products[productIdx].isDisabled = true;
        this.state.dataSource.rows[planAspIdx].products[productIdx].quarters.forEach((quarter) => {
          quarter.isDisabled = true;
        });
      } else {
        /*Calculation of Revenue when UNIT is edited*/
        this.state.dataSource.rows[planAspIdx].products[productIdx].quarters
          .filter((aspQuarter) => !aspQuarter.isPast)
          .forEach((aspQuarter) => {
            this.state.dataSource.rows[rowIdx].products[productIdx].quarters
              .filter((unitQuarter) => !unitQuarter.isPast && unitQuarter.name == aspQuarter.name)
              .forEach((unitQuarter) => {
                this.state.dataSource.rows[planQuotaIdx].products[productIdx].quarters
                  .filter((planQuotaQuarter) => !planQuotaQuarter.isPast && planQuotaQuarter.name == aspQuarter.name)
                  .forEach((planQuotaQuarter) => {
                    // Sales update
                    planQuotaQuarter.value = TwoDecimalPlace(unitQuarter.value * aspQuarter.value);
                    planQuotaQuarter.isChanged = true;

                    //Margin update
                    this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters
                      .filter((planMarginQuarter) => !planMarginQuarter.isPast && planMarginQuarter.name == planQuotaQuarter.name)
                      .forEach((planMarginQuarter) => {
                        //Calulate Margin % for Each Product from old Margin $ and old Sales Value
                        const oldMarginValue = planMarginQuarter.oldVal;
                        const oldSalesValue = planQuotaQuarter.oldVal;
                        const oldMarginPctValue = (oldMarginValue / oldSalesValue) * 100;

                        //Calculate Margin $
                        const newSalesValue = planQuotaQuarter.value;
                        planMarginQuarter.value = TwoDecimalPlace(newSalesValue * (oldMarginPctValue / 100));
                        planMarginQuarter.isChanged = true;
                        planMarginQuarter.isDisabled = true;

                      });
                  });
              });
          });

        this.state.dataSource.rows[planQuotaIdx].products[totalIdx].quarters.forEach((quarter, qIdx: number) => {
          quarter.value = calculateQuarterTotal(this.state.dataSource.rows[planQuotaIdx].products, qIdx, 'Plan / Quota - $');
        });

        this.state.dataSource.rows[planQuotaIdx].products[totalIdx].value =
          calculateMeasureTotal(this.state.dataSource.rows[planQuotaIdx].products, 'Plan / Quota - $');

        this.state.dataSource.rows[planQuotaIdx].products[productIdx].value =
          calculateEachProductTotal(this.state.dataSource.rows[planQuotaIdx].products[productIdx].quarters, 'Plan / Quota - $');

        //Margin $
        this.state.dataSource.rows[planMarginIdx].products[totalIdx].quarters.forEach((quarter, qIdx: number) => {
          quarter.value = calculateQuarterTotal(this.state.dataSource.rows[planMarginIdx].products, qIdx, 'Margin $');
        });

        this.state.dataSource.rows[planMarginIdx].products[totalIdx].value =
          calculateMeasureTotal(this.state.dataSource.rows[planMarginIdx].products, 'Margin $');

        this.state.dataSource.rows[planMarginIdx].products[productIdx].value =
          calculateEachProductTotal(this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters, 'Margin $');

      }
    }

    if (measureGroup === 'Plan / Quota - UNITS' && productName === 'Total') {
      const totalIdx = this.state.dataSource.rows[rowIdx].products.findIndex((product) => product.name === 'Total');

      /*Update total of all the products of Plan / Quota - UNITS*/
      this.state.dataSource.rows[rowIdx].products
        .filter((product, idx) => this.state.dataSource.rows[rowIdx].products.length - 1 !== idx)
        .forEach((product) => {
          product.value = Math.round((product.oldVal / this.state.dataSource.rows[rowIdx].products[totalIdx].oldVal) * value)
        });

      this.state.dataSource.rows[rowIdx].products.filter((product) => product.name !== 'Total').forEach((product) => {
        //past quarter value addition
        const qtrTotalPastVal = product.quarters.filter((quarter) => quarter.isPast).reduce((pastVal, qaurter) => {
          pastVal += qaurter.oldVal;
          return pastVal;
        }, 0);

        const qtrTotaleditableVal = product.quarters.filter((quarter) => !quarter.isPast).reduce((editableVal, qaurter) => {
          editableVal += qaurter.oldVal;
          return editableVal;
        }, 0);

        const remainingQtrToatlEditableVal = product.value - qtrTotalPastVal;
        /*Update all the quarters of Plan / Quota - UNITS*/
        product.quarters
          .filter((quarter) => !quarter.isPast)
          .forEach((quarter) => {
            quarter.value = quarter.oldVal !== 0
              ? Math.round((quarter.oldVal / qtrTotaleditableVal) * remainingQtrToatlEditableVal)
              : 0;
            quarter.isChanged = true;
          });
      });

      this.state.dataSource.rows[rowIdx].products[totalIdx].quarters.forEach((quarter, qIdx: number) => {
        quarter.value = calculateQuarterTotal(this.state.dataSource.rows[rowIdx].products, qIdx, measureGroup);
      });

      const planAspIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan ASP');
      const planValueIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - $');
      const planMarginIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Margin $');
      const avgIdx = this.state.dataSource.rows[planAspIdx].products.findIndex((product) => product.name === 'Average');

      /*edit control for dependent measures*/
      this.state.dataSource.rows[planAspIdx].products[avgIdx].isDisabled = false;
      this.state.dataSource.rows[planValueIdx].products[totalIdx].isDisabled = false;
      this.state.dataSource.rows[planMarginIdx].products[totalIdx].isDisabled = false;

      this.state.dataSource.rows[rowIdx].products[totalIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });
      this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });
      this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });
      this.state.dataSource.rows[planMarginIdx].products[totalIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });

      const isPlanAspEdited = this.state.dataSource.rows[planAspIdx].products[avgIdx].isEdited;
      const isPlanValueEdited = this.state.dataSource.rows[planValueIdx].products[totalIdx].isEdited;

      if (isPlanAspEdited) {
        /*Calculation of Plan Quota total when UNIT and ASP are edited*/
        const planUnitTotal = this.state.dataSource.rows[rowIdx].products[totalIdx].value;
        const planAspTotal = this.state.dataSource.rows[planAspIdx].products[avgIdx].value;

        this.state.dataSource.rows[planValueIdx].products[totalIdx].value = TwoDecimalPlace(planUnitTotal * planAspTotal);
        this.state.dataSource.rows[planValueIdx].products
          .filter((product, pIdx: number) => this.state.dataSource.rows[planValueIdx].products.length - 1 !== pIdx)
          .forEach((product) => {
            const oldTotalValue = this.state.dataSource.rows[planValueIdx].products[totalIdx].oldVal;
            const newTotalValue = this.state.dataSource.rows[planValueIdx].products[totalIdx].value;
            product.value =
              TwoDecimalPlace((product.oldVal / oldTotalValue) * newTotalValue);
          });
        this.state.dataSource.rows[planValueIdx].products.forEach((product) => {
          product.quarters.forEach((quarter) => {
            quarter.value = quarter.oldVal !== 0
              ? TwoDecimalPlace((quarter.oldVal / product.oldVal) * product.value)
              : 0;
            quarter.isChanged = true;
          });
        });

        this.state.dataSource.rows[planValueIdx].products[totalIdx].isDisabled = true;
        this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters.forEach((quarter) => {
          quarter.isDisabled = true;
        });
      } else if (isPlanValueEdited) {
        /*Calculation of ASP total when UNIT and Plan Quota are edited*/
        const planUnitTotal = this.state.dataSource.rows[rowIdx].products[totalIdx].value;
        const planValueTotal = this.state.dataSource.rows[planValueIdx].products[totalIdx].value;

        this.state.dataSource.rows[planAspIdx].products[avgIdx].value =
          planUnitTotal !== 0 ? TwoDecimalPlace(planValueTotal / planUnitTotal) : 0;
        this.state.dataSource.rows[planAspIdx].products
          .filter((product, pIdx: number) => this.state.dataSource.rows[planAspIdx].products.length - 1 !== pIdx)
          .forEach((product, pIdx: number) => {
            const planUnitValue = this.state.dataSource.rows[rowIdx].products[pIdx].value;
            const planQuotaValue = this.state.dataSource.rows[planValueIdx].products[pIdx].value;
            product.value = planUnitValue !== 0 ? TwoDecimalPlace(planQuotaValue / planUnitValue) : 0;
          });
        this.state.dataSource.rows[planAspIdx].products.forEach((product) => {
          product.quarters.forEach((quarter) => {
            quarter.value = quarter.oldVal !== 0
              ? TwoDecimalPlace((quarter.oldVal / product.oldVal) * product.value)
              : 0;
          });
        });

        this.state.dataSource.rows[planAspIdx].products[avgIdx].isDisabled = true;
        this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters.forEach((quarter) => {
          quarter.isDisabled = true;
        });
      } else {

        this.state.dataSource.rows[planAspIdx].products
          .filter((product) => product.name !== 'Average')
          .forEach((product, Idx) => {
            product.quarters.filter((quarter) => !quarter.isPast)
              .forEach((aspQuarter) => {
                this.state.dataSource.rows[rowIdx].products[Idx].quarters
                  .filter((unitQuarter) => !unitQuarter.isPast && unitQuarter.name == aspQuarter.name)
                  .forEach((unitQuarter, qIndx) => {
                    this.state.dataSource.rows[planValueIdx].products[Idx].quarters
                      .filter((planQuotaQuarter) => !planQuotaQuarter.isPast && planQuotaQuarter.name == aspQuarter.name)
                      .forEach((planQuotaQuarter) => {
                        planQuotaQuarter.value = TwoDecimalPlace(unitQuarter.value * aspQuarter.value);
                        planQuotaQuarter.isChanged = true;

                        //Margin update
                        this.state.dataSource.rows[planMarginIdx].products[Idx].quarters
                          .filter((planMarginQuarter) => !planMarginQuarter.isPast && planMarginQuarter.name == planQuotaQuarter.name)
                          .forEach((planMarginQuarter) => {
                            //Calulate Margin % for Each Product from old Margin $ and old Sales Value
                            const oldMarginValue = planMarginQuarter.oldVal;
                            const oldSalesValue = planQuotaQuarter.oldVal;
                            const oldMarginPctValue = (oldMarginValue / oldSalesValue) * 100;

                            //Calculate Margin $
                            const newSalesValue = planQuotaQuarter.value;
                            planMarginQuarter.value = TwoDecimalPlace(newSalesValue * (oldMarginPctValue / 100));
                            planMarginQuarter.isChanged = true;
                            planMarginQuarter.isDisabled = true;

                          });

                      });

                  });

              });

          });

        // Quarter wise Total
        this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters.forEach((quarter, qIdx: number) => {
          quarter.value = calculateQuarterTotal(this.state.dataSource.rows[planValueIdx].products, qIdx, 'Plan / Quota - $');
        });

        //Each Product Totall
        this.state.dataSource.rows[planValueIdx].products.forEach((product) => {
          product.value = calculateEachProductTotal(product.quarters, 'Plan / Quota - $');
        });

        // Quarter wise Total Margin $
        this.state.dataSource.rows[planMarginIdx].products[totalIdx].quarters.forEach((quarter, qIdx: number) => {
          quarter.value = calculateQuarterTotal(this.state.dataSource.rows[planMarginIdx].products, qIdx, 'Margin $');
        });

        //Each Product Totall Margin $
        this.state.dataSource.rows[planMarginIdx].products.forEach((product) => {
          product.value = calculateEachProductTotal(product.quarters, 'Margin $');
        });
      }
    }

    if (measureGroup === 'Plan / Quota - $' && productName !== 'Total') {
      /*Update quarters and measure total of Plan / Quota - $*/
      const planMarginIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Margin $');
      const productDetails = this.state.dataSource.rows[rowIdx].products[productIdx];
      this.state.dataSource.rows[rowIdx].products[productIdx].quarters
        .filter((quarter) => !quarter.isPast)
        .forEach((quarter) => {
          quarter.value = TwoDecimalPlace((quarter.oldVal / editableQuarterTotal) * remainingVal);
          quarter.isChanged = true;

          this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters
            .filter((marginQuarter) => !quarter.isPast && marginQuarter.name == quarter.name)
            .forEach((marginQuarter) => {

              // Calculate Margin % for Each Product from old Margin $ and old Sales Value
              const oldMarginValue = marginQuarter.oldVal;
              const oldSalesValue = quarter.oldVal;
              const oldMarginPctValue = (oldMarginValue / oldSalesValue) * 100;

              // Calculate Margin $
              const newSalesValue = quarter.value;
              marginQuarter.value = TwoDecimalPlace(newSalesValue * (oldMarginPctValue / 100));
              marginQuarter.isChanged = true;
              marginQuarter.isDisabled = true;
            });
        });

      const totalIdx = this.state.dataSource.rows[rowIdx].products.findIndex((product) => product.name === 'Total');
      /*this.state.dataSource.rows[rowIdx].products[totalIdx].value =
        calculateMeasureTotal(this.state.dataSource.rows[rowIdx].products, measureGroup);
      */
      this.state.dataSource.rows[rowIdx].products[totalIdx].quarters
      //.filter((quarter) => !quarter.isPast)
        .forEach((quarter, qIdx: number) => {
          quarter.value = calculateQuarterTotal(this.state.dataSource.rows[rowIdx].products, qIdx, measureGroup);
        });

      this.state.dataSource.rows[rowIdx].products[totalIdx].value =
        calculateMeasureTotal(this.state.dataSource.rows[rowIdx].products, measureGroup);

      // Margin $
      this.state.dataSource.rows[planMarginIdx].products[totalIdx].quarters
        .forEach((quarter, qIdx: number) => {
          quarter.value = calculateQuarterTotal(this.state.dataSource.rows[planMarginIdx].products, qIdx, 'Margin $');
        });

      this.state.dataSource.rows[planMarginIdx].products[totalIdx].value =
        calculateMeasureTotal(this.state.dataSource.rows[planMarginIdx].products, 'Margin $');

      this.state.dataSource.rows[planMarginIdx].products[productIdx].value =
        calculateEachProductTotal(this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters, 'Margin $')


      /*edit control for dependent measures*/
      const planUnitIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - UNITS');
      const planAspIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan ASP');

      const avgIdx = this.state.dataSource.rows[planAspIdx].products.findIndex((product) => product.name === 'Average');

      this.state.dataSource.rows[planAspIdx].products[productIdx].isDisabled = false;
      this.state.dataSource.rows[planUnitIdx].products[productIdx].isDisabled = false;
      this.state.dataSource.rows[planMarginIdx].products[productIdx].isDisabled = true;


      this.state.dataSource.rows[rowIdx].products[productIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });
      this.state.dataSource.rows[planAspIdx].products[productIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });
      this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });
      this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });

      const isPlanAspEdited = this.state.dataSource.rows[planAspIdx].products[productIdx].isEdited;
      const isPlanUnitEdited = this.state.dataSource.rows[planUnitIdx].products[productIdx].isEdited;

      if (isPlanAspEdited) {
        /*Calculation of UNIT when Plan Quota and ASP are edited*/
        const planAspValue = this.state.dataSource.rows[planAspIdx].products[productIdx].value;
        this.state.dataSource.rows[planUnitIdx].products[productIdx].value =
          planAspValue !== 0 ? Math.round(value / planAspValue) : 0;
        this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters.forEach((quarter, qIdx: number) => {
          quarter.value = calculateQuarterValue(rowArr, planUnitIdx, productIdx, qIdx, 'Plan / Quota - UNITS');
        });

        this.state.dataSource.rows[planUnitIdx].products[productIdx].isDisabled = true;
        this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters.forEach((quarter) => {
          quarter.isDisabled = true;
        });
      } else if (isPlanUnitEdited) {
        /*Calculation of ASP when Plan Quota and UNIT are edited*/
        const planUnitValue = this.state.dataSource.rows[planUnitIdx].products[productIdx].value;
        this.state.dataSource.rows[planAspIdx].products[productIdx].value =
          planUnitValue !== 0 ? TwoDecimalPlace(value / planUnitValue) : 0;
        this.state.dataSource.rows[planAspIdx].products[productIdx].quarters.forEach((quarter, qIdx: number) => {
          quarter.value = calculateQuarterValue(rowArr, planAspIdx, productIdx, qIdx, 'Plan ASP');
        });

        const planUnitTotal = this.state.dataSource.rows[planUnitIdx].products[totalIdx].value;
        const planValueTotal = this.state.dataSource.rows[rowIdx].products[totalIdx].value;
        this.state.dataSource.rows[planAspIdx].products[avgIdx].value =
          planUnitTotal !== 0 ? TwoDecimalPlace(planValueTotal / planUnitTotal) : 0;
        this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters.forEach((quarter, qIdx: number) => {
          quarter.value = calculateQuarterValue(rowArr, planAspIdx, avgIdx, qIdx, 'Plan ASP');
        });

        this.state.dataSource.rows[planAspIdx].products[productIdx].isDisabled = true;
        this.state.dataSource.rows[planAspIdx].products[productIdx].quarters.forEach((quarter) => {
          quarter.isDisabled = true;
        });
      } else {
        const planAspValue = this.state.dataSource.rows[planAspIdx].products[productIdx].value;
        this.state.dataSource.rows[planUnitIdx].products[productIdx].value =
          planAspValue !== 0 ? Math.round(value / planAspValue) : 0;
        const productDetails = this.state.dataSource.rows[planUnitIdx].products[productIdx];
        this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters.forEach((quarter) => {
          quarter.value = productDetails.oldVal !== 0
            ? Math.round((quarter.oldVal / productDetails.oldVal) * productDetails.value)
            : 0;
          quarter.isChanged = true;
        });

        this.state.dataSource.rows[planUnitIdx].products[totalIdx].value =
          calculateMeasureTotal(this.state.dataSource.rows[rowIdx].products, 'Plan / Quota - UNITS');
        this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters.forEach((quarter, qIdx: number) => {
          quarter.value = calculateQuarterTotal(this.state.dataSource.rows[planUnitIdx].products, qIdx, 'Plan / Quota - UNITS');
        });
      }
    }

    if (measureGroup === 'Plan / Quota - $' && productName === 'Total') {
      const totalIdx = this.state.dataSource.rows[rowIdx].products.findIndex((product) => product.name === 'Total');

      /*Update total of all the products of Plan / Quota - $*/
      this.state.dataSource.rows[rowIdx].products
        .filter((product, idx) => this.state.dataSource.rows[rowIdx].products.length - 1 !== idx)
        .forEach((product) => {
          product.value = TwoDecimalPlace((product.oldVal / this.state.dataSource.rows[rowIdx].products[totalIdx].oldVal) * value);
        });

      this.state.dataSource.rows[rowIdx].products.filter((product) => product.name !== 'Total').forEach((product) => {

        //past quarter value addition
        const qtrTotalPastVal = product.quarters.filter((quarter) => quarter.isPast).reduce((pastVal, qaurter) => {
          pastVal += qaurter.oldVal;
          return pastVal;
        }, 0);

        const qtrTotaleditableVal = product.quarters.filter((quarter) => !quarter.isPast).reduce((editableVal, qaurter) => {
          editableVal += qaurter.oldVal;
          return editableVal;
        }, 0);

        const remainingQtrToatlEditableVal = product.value - qtrTotalPastVal;
        /*Update all the quarters of Plan / Quota - UNITS*/
        product.quarters
          .filter((quarter) => !quarter.isPast)
          .forEach((quarter) => {
            quarter.value = quarter.oldVal !== 0
              ? Math.round((quarter.oldVal / qtrTotaleditableVal) * remainingQtrToatlEditableVal)
              : 0;
            quarter.isChanged = true;
          });
      });

      this.state.dataSource.rows[rowIdx].products[totalIdx].quarters.forEach((quarter, qIdx: number) => {
        quarter.value = calculateQuarterTotal(this.state.dataSource.rows[rowIdx].products, qIdx, measureGroup);
      });

      /*edit control for dependent measures*/
      const planAspIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan ASP');
      const planUnitIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - UNITS');
      const planMarginIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Margin $');
      const avgIdx = this.state.dataSource.rows[planAspIdx].products.findIndex((product) => product.name === 'Average');

      this.state.dataSource.rows[planAspIdx].products[totalIdx].isDisabled = false;
      this.state.dataSource.rows[planUnitIdx].products[totalIdx].isDisabled = false;
      this.state.dataSource.rows[planMarginIdx].products[totalIdx].isDisabled = false;

      this.state.dataSource.rows[rowIdx].products[totalIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });
      this.state.dataSource.rows[planAspIdx].products[totalIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });
      this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });
      this.state.dataSource.rows[planMarginIdx].products[totalIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });

      const isPlanAspEdited = this.state.dataSource.rows[planAspIdx].products[totalIdx].isEdited;
      const isPlanUnitEdited = this.state.dataSource.rows[planUnitIdx].products[totalIdx].isEdited;

      if (isPlanAspEdited) {
        /*Calculation of UNIT total when Plan Quota and ASP are edited*/
        const planValueTotal = this.state.dataSource.rows[rowIdx].products[totalIdx].value;
        const planAspTotal = this.state.dataSource.rows[planAspIdx].products[avgIdx].value;

        this.state.dataSource.rows[planUnitIdx].products[totalIdx].value =
          planAspTotal !== 0 ? Math.round(planValueTotal / planAspTotal) : 0;
        this.state.dataSource.rows[planUnitIdx].products
          .filter((product, pIdx: number) => this.state.dataSource.rows[planUnitIdx].products.length - 1 !== pIdx)
          .forEach((product, pIdx: number) => {
            const planQuotaValue = this.state.dataSource.rows[rowIdx].products[pIdx].value;
            const planAspValue = this.state.dataSource.rows[planAspIdx].products[pIdx].value;
            product.value = planAspValue !== 0 ? Math.round(planQuotaValue / planAspValue) : 0;
          });
        this.state.dataSource.rows[planUnitIdx].products.forEach((product) => {
          product.quarters.forEach((quarter) => {
            quarter.value = quarter.oldVal !== 0
              ? Math.round((quarter.oldVal / product.oldVal) * product.value)
              : 0;
            quarter.isChanged = true;
          });
        });

        this.state.dataSource.rows[planUnitIdx].products[totalIdx].isDisabled = true;
        this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters.forEach((quarter) => {
          quarter.isDisabled = true;
        });
      } else if (isPlanUnitEdited) {
        /*Calculation of ASP when UNIT and Plan Quota are edited*/
        const planUnitValue = this.state.dataSource.rows[planUnitIdx].products[productIdx].value;
        this.state.dataSource.rows[planAspIdx].products[productIdx].value =
          planUnitValue !== 0 ? TwoDecimalPlace(value / planUnitValue) : 0;
        const productDetails = this.state.dataSource.rows[planAspIdx].products[productIdx];
        this.state.dataSource.rows[planAspIdx].products[productIdx].quarters.forEach((quarter) => {
          quarter.value = productDetails.oldVal !== 0
            ? TwoDecimalPlace((quarter.oldVal / productDetails.oldVal) * productDetails.value)
            : 0;
        });

        /*Calculation of ASP total when UNIT and Plan Quota are edited*/
        this.state.dataSource.rows[planAspIdx].products[totalIdx].value =
          calculateEachProductTotal(
            this.state.dataSource.rows[planAspIdx].products[totalIdx].quarters, 'Plan ASP'
          );
        this.state.dataSource.rows[planAspIdx].products
          .filter((product, pIdx: number) => this.state.dataSource.rows[planAspIdx].products.length - 1 !== pIdx)
          .forEach((product, pIdx: number) => {
            const planUnitValue = this.state.dataSource.rows[planUnitIdx].products[pIdx].value;
            const planQuotaValue = this.state.dataSource.rows[rowIdx].products[pIdx].value;
            product.value = planUnitValue !== 0 ? TwoDecimalPlace(planQuotaValue / planUnitValue) : 0;
          });
        this.state.dataSource.rows[planAspIdx].products.forEach((product) => {
          product.quarters.forEach((quarter) => {
            quarter.value = quarter.oldVal !== 0
              ? TwoDecimalPlace((quarter.oldVal / product.oldVal) * product.value)
              : 0;
          });
        });

        this.state.dataSource.rows[planAspIdx].products[totalIdx].isDisabled = true;
        this.state.dataSource.rows[planAspIdx].products[totalIdx].quarters.forEach((quarter) => {
          quarter.isDisabled = true;
        });
      } else {
        this.state.dataSource.rows[planAspIdx].products
          .filter((product) => product.name !== 'Average')
          .forEach((product, Idx) => {
            product.quarters.filter((quarter) => !quarter.isPast)
              .forEach((aspQuarter) => {
                this.state.dataSource.rows[planUnitIdx].products[Idx].quarters
                  .filter((unitQuarter) => !unitQuarter.isPast && unitQuarter.name == aspQuarter.name)
                  .forEach((unitQuarter, qIndx) => {
                    this.state.dataSource.rows[rowIdx].products[Idx].quarters
                      .filter((planQuotaQuarter) => !planQuotaQuarter.isPast && planQuotaQuarter.name == aspQuarter.name)
                      .forEach((planQuotaQuarter) => {
                        unitQuarter.value = planQuotaQuarter.value != 0 ? Math.round(planQuotaQuarter.value / aspQuarter.value) : 0;
                        unitQuarter.isChanged = true;

                        //Margin update
                        this.state.dataSource.rows[planMarginIdx].products[Idx].quarters
                          .filter((planMarginQuarter) => !planMarginQuarter.isPast && planMarginQuarter.name == planQuotaQuarter.name)
                          .forEach((planMarginQuarter) => {
                            //Calulate Margin % for Each Product from old Margin $ and old Sales Value
                            const oldMarginValue = planMarginQuarter.oldVal;
                            const oldSalesValue = planQuotaQuarter.oldVal;
                            const oldMarginPctValue = (oldMarginValue / oldSalesValue) * 100;

                            //Calculate Margin $
                            const newSalesValue = planQuotaQuarter.value;
                            planMarginQuarter.value = TwoDecimalPlace(newSalesValue * (oldMarginPctValue / 100));
                            planMarginQuarter.isChanged = true;
                            planMarginQuarter.isDisabled = true;
                          });
                      });
                  });
              });
          });

        // Quarter wise Total
        this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters.forEach((quarter, qIdx: number) => {
          quarter.value = calculateQuarterTotal(this.state.dataSource.rows[planUnitIdx].products, qIdx, 'Plan / Quota - UNITS');
        });

        //Each Product Totall
        this.state.dataSource.rows[planUnitIdx].products.forEach((product) => {
          product.value = calculateEachProductTotal(product.quarters, 'Plan / Quota - UNITS');
        });

        // Quarter wise Total Margin $
        this.state.dataSource.rows[planMarginIdx].products[totalIdx].quarters.forEach((quarter, qIdx: number) => {
          quarter.value = calculateQuarterTotal(this.state.dataSource.rows[planMarginIdx].products, qIdx, 'Margin $');
        });

        //Each Product Totall Margin $
        this.state.dataSource.rows[planMarginIdx].products.forEach((product) => {
          product.value = calculateEachProductTotal(product.quarters, 'Margin $');
        });
      }
    }

    if (measureGroup === 'Plan ASP' && productName !== 'Average') {
      /*Update quarters and measure total of Plan ASP*/
      /*this.state.dataSource.rows[rowIdx].products[productIdx].quarters.forEach((quarter) => {
        quarter.value = value;
      });
      */

      const planUnitIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - UNITS');
      const planValueIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - $');
      const planMarginIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Margin $');

      const unitTotalIdx = this.state.dataSource.rows[planUnitIdx].products.findIndex((product) => product.name === 'Total');
      const valueTotalIdx = this.state.dataSource.rows[planValueIdx].products.findIndex((product) => product.name === 'Total');
      const avgIdx = this.state.dataSource.rows[rowIdx].products.findIndex((product) => product.name === 'Average');
      const marginTotalIdx = this.state.dataSource.rows[planMarginIdx].products.findIndex((product) => product.name === 'Total');

      const planQuotaValue = this.state.dataSource.rows[planValueIdx].products[productIdx].value;
      const planUnitValue = this.state.dataSource.rows[planUnitIdx].products[productIdx].value;

      this.state.dataSource.rows[planUnitIdx].products[productIdx].value =  value !== 0 ?TwoDecimalPlace(planQuotaValue / value):0;
      const newplanUnit = this.state.dataSource.rows[planUnitIdx].products[productIdx].value

      const pastQuarterTotalA = this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters
        .filter((quarter) => quarter.isPast)
        .reduce((pastVal, qaurter) => {
          pastVal += qaurter.oldVal;
          return pastVal;
        }, 0);

      const editableQuarterTotalA = this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters
        .filter((quarter) => !quarter.isPast)
        .reduce((pastVal, qaurter) => {
          pastVal += qaurter.oldVal;
          return pastVal;
        }, 0);

      const remainingValA = newplanUnit - pastQuarterTotalA;

      /*edit control for dependent measures*/
      this.state.dataSource.rows[planValueIdx].products[productIdx].isDisabled = false;
      this.state.dataSource.rows[planUnitIdx].products[productIdx].isDisabled = false;

      this.state.dataSource.rows[rowIdx].products[productIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });
      this.state.dataSource.rows[planValueIdx].products[productIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
        quarter.isChanged = true;
      });
      this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });

      const isPlanValueEdited = this.state.dataSource.rows[planValueIdx].products[productIdx].isEdited;
      const isPlanUnitEdited = this.state.dataSource.rows[planUnitIdx].products[productIdx].isEdited;

      if (isPlanValueEdited) {
        /*Calculation of UNIT when ASP and Plan Quota are edited*/
        const planQuotaValue = this.state.dataSource.rows[planValueIdx].products[productIdx].value;
        this.state.dataSource.rows[planUnitIdx].products[productIdx].value =
          value !== 0 ? Math.round(planQuotaValue / value) : 0;
        const productDetails = this.state.dataSource.rows[planUnitIdx].products[productIdx];
        this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters.forEach((quarter) => {
          quarter.value = Math.round((quarter.oldVal / productDetails.oldVal) * productDetails.value);
        });

        /*Calculation of UNIT total when ASP and Plan Quota are edited*/
        this.state.dataSource.rows[planUnitIdx].products[unitTotalIdx].value =
          calculateEachProductTotal(
            this.state.dataSource.rows[planUnitIdx].products[unitTotalIdx].quarters, 'Plan / Quota - UNITS'
          );
        this.state.dataSource.rows[planUnitIdx].products[unitTotalIdx].quarters.forEach((quarter, qIdx: number) => {
          quarter.value = calculateQuarterTotal(this.state.dataSource.rows[planUnitIdx].products, qIdx, 'Plan / Quota - UNITS');
        });

        this.state.dataSource.rows[planUnitIdx].products[productIdx].isDisabled = true;
        this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters.forEach((quarter) => {
          quarter.isDisabled = true;
        });
      } else if (isPlanUnitEdited) {
        /*Calculation of Plan Quota when ASP and UNIT are edited*/
        const planUnitValue = this.state.dataSource.rows[planUnitIdx].products[productIdx].value;
        this.state.dataSource.rows[planValueIdx].products[productIdx].value =
          TwoDecimalPlace(planUnitValue * value);
        const productDetails = this.state.dataSource.rows[planValueIdx].products[productIdx];
        this.state.dataSource.rows[planValueIdx].products[productIdx].quarters.forEach((quarter) => {
          quarter.value = Math.round((quarter.oldVal / productDetails.oldVal) * productDetails.value);
        });

        /*Calculation of Plan Quota total when ASP and UNIT are edited*/
        this.state.dataSource.rows[planValueIdx].products[valueTotalIdx].value =
          calculateEachProductTotal(
            this.state.dataSource.rows[planValueIdx].products[valueTotalIdx].quarters, 'Plan / Quota - $'
          );
        this.state.dataSource.rows[planValueIdx].products[valueTotalIdx].quarters.forEach((quarter, qIdx: number) => {
          quarter.value = calculateQuarterTotal(this.state.dataSource.rows[planValueIdx].products, qIdx, 'Plan / Quota - $');
        });

        this.state.dataSource.rows[planValueIdx].products[productIdx].isDisabled = true;
        this.state.dataSource.rows[planValueIdx].products[productIdx].quarters.forEach((quarter) => {
          quarter.isDisabled = true;
        });
      } else {

        //const productDetails = this.state.dataSource.rows[planValueIdx].products[productIdx];
        this.state.dataSource.rows[planValueIdx].products[productIdx].quarters
          .filter((quarter) => !quarter.isPast)
          .forEach((quarter) => {
            quarter.value = quarter.oldVal > 0
              ? TwoDecimalPlace((quarter.oldVal / editableQuarterTotalA) * remainingValA)
              : 0;
            quarter.isChanged = true;

            //Margin Calculation
            this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters
              .filter((planMarginQuarter) => !planMarginQuarter.isPast && planMarginQuarter.name == quarter.name)
              .forEach((planMarginQuarter) => {

                //Calulate Margin % for Each Product from old Margin $ and old Sales Value
                const oldMarginValue = planMarginQuarter.oldVal;
                const oldSalesValue = quarter.oldVal;
                const oldMarginPctValue = (oldMarginValue / oldSalesValue) * 100;

                //Calculate Margin $
                const newSalesValue = quarter.value;
                planMarginQuarter.value = TwoDecimalPlace(newSalesValue * (oldMarginPctValue / 100));
                planMarginQuarter.isChanged = true;
                planMarginQuarter.isDisabled = true;
              });
          });

        this.state.dataSource.rows[planValueIdx].products[valueTotalIdx].quarters.forEach((quarter, qIdx: number) => {
          quarter.value = calculateQuarterTotal(this.state.dataSource.rows[planValueIdx].products, qIdx, 'Plan / Quota - $');
        });

        this.state.dataSource.rows[planValueIdx].products[valueTotalIdx].value =
          calculateMeasureTotal(this.state.dataSource.rows[planValueIdx].products, 'Plan / Quota - $');

        // Margin $
        this.state.dataSource.rows[planMarginIdx].products[marginTotalIdx].quarters
          .forEach((quarter, qIdx: number) => {
            quarter.value = calculateQuarterTotal(this.state.dataSource.rows[planMarginIdx].products, qIdx, 'Margin $');
          });

        this.state.dataSource.rows[planMarginIdx].products[marginTotalIdx].value =
          calculateMeasureTotal(this.state.dataSource.rows[planMarginIdx].products, 'Margin $');

        this.state.dataSource.rows[planMarginIdx].products[productIdx].value =
          calculateEachProductTotal(this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters, 'Margin $');

        // Calulate quarter of ASP based on Revenue and Unit
        this.state.dataSource.rows[rowIdx].products[productIdx].quarters
          .filter((quarter) => !quarter.isPast)
          .forEach((quarter, qIdx: number) => {
            this.state.dataSource.rows[planValueIdx].products[productIdx].quarters
              .filter((valQuarter) => !valQuarter.isPast && valQuarter.name == quarter.name)
              .forEach((valQuarter) => {

                this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters
                  .filter((unitquarter) => !unitquarter.isPast && unitquarter.name == quarter.name)
                  .forEach((unitquarter) => {
                    const qValue = valQuarter.value;
                    const qUnit = unitquarter.value;
                    quarter.value = qUnit !== 0 ? TwoDecimalPlace(qValue / qUnit) : 0;
                  });
              });
          });

        // Calculate Average of each quarter
        this.state.dataSource.rows[rowIdx].products[avgIdx].quarters
          .filter((quarter) => !quarter.isPast)
          .forEach((quarter) => {
            this.state.dataSource.rows[planValueIdx].products[valueTotalIdx].quarters
              .filter((valquarter) => !valquarter.isPast && valquarter.name == quarter.name)
              .forEach((valquarter) => {
                this.state.dataSource.rows[planUnitIdx].products[unitTotalIdx].quarters
                  .filter((unitquarter) => !unitquarter.isPast && unitquarter.name == quarter.name)
                  .forEach((unitquarter) => {
                    const qValue = valquarter.value;
                    const qUnit = unitquarter.value;
                    quarter.value = qUnit !== 0 ? TwoDecimalPlace(qValue / qUnit) : 0;
                  });
              });
          });

        const planValueTotal = this.state.dataSource.rows[planValueIdx].products[valueTotalIdx].value;
        const planUnitTotal = this.state.dataSource.rows[planUnitIdx].products[unitTotalIdx].value;
        this.state.dataSource.rows[rowIdx].products[avgIdx].value =
          planUnitTotal !== 0 ? TwoDecimalPlace(planValueTotal / planUnitTotal) : 0;
      }
    }

    if (measureGroup === 'Plan ASP' && productName === 'Average') {
      const planUnitIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - UNITS');
      const planValueIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - $');
      const planQuotaValue = this.state.dataSource.rows[planValueIdx].products[productIdx].value;
      const unitTotalIdx = this.state.dataSource.rows[planUnitIdx].products.findIndex((product) => product.name === 'Total');
      const valueTotalIdx = this.state.dataSource.rows[planValueIdx].products.findIndex((product) => product.name === 'Total');

      this.state.dataSource.rows[rowIdx].products
        .filter((product, idx) => this.state.dataSource.rows[rowIdx].products.length - 1 !== idx)
        .forEach((product) => {
          product.value = this.state.dataSource.rows[rowIdx].products[productIdx].oldVal !== 0
            ? TwoDecimalPlace((product.oldVal / this.state.dataSource.rows[rowIdx].products[productIdx].oldVal) * value)
            : 0;
        });

      this.state.dataSource.rows[rowIdx].products.forEach((product) => {
        product.quarters
          .filter((quarter) => !quarter.isPast)
          .forEach((quarter) => {
            quarter.value = quarter.oldVal !== 0
              ? TwoDecimalPlace((quarter.oldVal / product.oldVal) * product.value)
              : 0;
          });
      });

      /*edit control for dependent measures*/
      this.state.dataSource.rows[planValueIdx].products[valueTotalIdx].isDisabled = false;
      this.state.dataSource.rows[planUnitIdx].products[unitTotalIdx].isDisabled = false;

      this.state.dataSource.rows[rowIdx].products[productIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });
      this.state.dataSource.rows[planValueIdx].products[valueTotalIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });
      this.state.dataSource.rows[planUnitIdx].products[unitTotalIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });

      const isPlanValueEdited = this.state.dataSource.rows[planValueIdx].products[valueTotalIdx].isEdited;
      const isPlanUnitEdited = this.state.dataSource.rows[planUnitIdx].products[unitTotalIdx].isEdited;

      if (isPlanValueEdited) {
        /*Calculation of UNIT total when ASP and Plan Quota are edited*/
        const planAspTotal = this.state.dataSource.rows[rowIdx].products[productIdx].value;
        const planValueTotal = this.state.dataSource.rows[planValueIdx].products[valueTotalIdx].value;

        this.state.dataSource.rows[planUnitIdx].products[unitTotalIdx].value =
          planAspTotal !== 0 ? Math.round(planValueTotal / planAspTotal) : 0;
        this.state.dataSource.rows[planUnitIdx].products
          .filter((product, pIdx: number) => this.state.dataSource.rows[planUnitIdx].products.length - 1 !== pIdx)
          .forEach((product, pIdx: number) => {
            const planQuotaValue = this.state.dataSource.rows[planValueIdx].products[pIdx].value;
            const planAspValue = this.state.dataSource.rows[rowIdx].products[pIdx].value;
            product.value = planAspValue !== 0 ? Math.round(planQuotaValue / planAspValue) : 0;
          });
        this.state.dataSource.rows[planUnitIdx].products.forEach((product) => {
          product.quarters.forEach((quarter) => {
            quarter.value = quarter.oldVal !== 0
              ? TwoDecimalPlace((quarter.oldVal / product.oldVal) * product.value)
              : 0;
            quarter.isChanged = true;
          });
        });

        this.state.dataSource.rows[planUnitIdx].products[unitTotalIdx].isDisabled = true;
        this.state.dataSource.rows[planUnitIdx].products[unitTotalIdx].quarters.forEach((quarter) => {
          quarter.isDisabled = true;
        });
      } else if (isPlanUnitEdited) {
        /*Calculation of Plan Quota total when UNIT and ASP are edited*/
        const planAspTotal = this.state.dataSource.rows[rowIdx].products[productIdx].value;
        const planUnitTotal = this.state.dataSource.rows[planUnitIdx].products[unitTotalIdx].value;

        this.state.dataSource.rows[planValueIdx].products[valueTotalIdx].value =
          TwoDecimalPlace(planUnitTotal * planAspTotal);
        this.state.dataSource.rows[planValueIdx].products
          .filter((product, pIdx: number) => this.state.dataSource.rows[planValueIdx].products.length - 1 !== pIdx)
          .forEach((product) => {
            const oldTotalValue = this.state.dataSource.rows[planValueIdx].products[valueTotalIdx].oldVal;
            const newTotalValue = this.state.dataSource.rows[planValueIdx].products[valueTotalIdx].value;
            product.value =
              TwoDecimalPlace((product.oldVal / oldTotalValue) * newTotalValue);
          });
        this.state.dataSource.rows[planValueIdx].products.forEach((product) => {
          product.quarters.forEach((quarter) => {
            quarter.value = quarter.oldVal !== 0
              ? TwoDecimalPlace((quarter.oldVal / product.oldVal) * product.value)
              : 0;
            quarter.isChanged = true;
          });
        });

        this.state.dataSource.rows[planValueIdx].products[valueTotalIdx].isDisabled = true;
        this.state.dataSource.rows[planValueIdx].products[valueTotalIdx].quarters.forEach((quarter) => {
          quarter.isDisabled = true;
        });
      } else {
        this.state.dataSource.rows[planValueIdx].products[unitTotalIdx].value =
          TwoDecimalPlace(this.state.dataSource.rows[planUnitIdx].products[productIdx].oldVal * value);
        //Math.round(planQuotaValue / value);

        this.state.dataSource.rows[planValueIdx].products
          .filter((product, idx) => this.state.dataSource.rows[planValueIdx].products.length - 1 !== idx)
          .forEach((product) => {
            product.value = TwoDecimalPlace(
              (product.oldVal / this.state.dataSource.rows[planValueIdx].products[unitTotalIdx].oldVal) *
              this.state.dataSource.rows[planValueIdx].products[unitTotalIdx].value
            );
          });

        this.state.dataSource.rows[planValueIdx].products.forEach((product) => {
          product.quarters
            .filter((quarter) => !quarter.isPast)
            .forEach((quarter) => {
              quarter.value = quarter.oldVal !== 0
                ? TwoDecimalPlace((quarter.oldVal / product.oldVal) * product.value)
                : 0;
              quarter.isChanged = true;
            });
        });
        this.state.dataSource.rows[planValueIdx].products.forEach((product) => {
          product.quarters.forEach((quarter) => {
            quarter.isChanged = true;
          });
        });
      }
    }

    if (measureGroup === 'Margin %' && productName !== 'Average') {
      /*Update quarters and measure total of Margin %*/
      this.state.dataSource.rows[rowIdx].products[productIdx].quarters.forEach((quarter) => {
        quarter.value = value;
      });

      const planValueIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - $');
      const marginValueIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Margin $');
      const planQuotaValue = this.state.dataSource.rows[planValueIdx].products[productIdx].value;

      this.state.dataSource.rows[marginValueIdx].products[productIdx].value =
        TwoDecimalPlace((planQuotaValue * value) / 100);

      this.state.dataSource.rows[marginValueIdx].products[productIdx].quarters
        .filter((quarter) => !quarter.isPast)
        .forEach((quarter, qIdx: number) => {
          const quarterValue = this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[qIdx].value;
          quarter.value = TwoDecimalPlace((quarterValue * value) / 100);
          quarter.isChanged = true;
        });

      const totalIdx = this.state.dataSource.rows[marginValueIdx].products.findIndex((product) => product.name === 'Total');
      this.state.dataSource.rows[marginValueIdx].products[totalIdx].quarters
        .filter((quarter) => !quarter.isPast)
        .forEach((quarter, qIdx: number) => {
          quarter.value =
            calculateQuarterTotal(this.state.dataSource.rows[marginValueIdx].products, qIdx, 'Margin $');
        });

      this.state.dataSource.rows[marginValueIdx].products[totalIdx].value =
        calculateEachProductTotal(
          this.state.dataSource.rows[marginValueIdx].products[totalIdx].quarters,
          'Margin $'
        );

      const avgIdx = this.state.dataSource.rows[rowIdx].products.findIndex((product) => product.name === 'Average');
      this.state.dataSource.rows[rowIdx].products[avgIdx].quarters
        .filter((quarter) => !quarter.isPast)
        .forEach((quarter, qIdx: number) => {
          const qPlanValue = this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[qIdx].value;
          const qMarginValue = this.state.dataSource.rows[marginValueIdx].products[totalIdx].quarters[qIdx].value;
          quarter.value = qPlanValue !== 0 ? TwoDecimalPlace((qMarginValue / qPlanValue) * 100) : 0;
        });

      const marginValueTotal = this.state.dataSource.rows[marginValueIdx].products[totalIdx].value;
      const planValueTotal = this.state.dataSource.rows[planValueIdx].products[totalIdx].value;
      this.state.dataSource.rows[rowIdx].products[avgIdx].value =
        planValueTotal !== 0 ? TwoDecimalPlace((marginValueTotal / planValueTotal) * 100) : 0;
    }

    if (measureGroup === 'Margin %' && productName === 'Average') {
      const marginValueIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Margin $');
      const planValueIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - $');
      const planQuotaValue = this.state.dataSource.rows[planValueIdx].products[productIdx].value;
      const totalIdx = this.state.dataSource.rows[marginValueIdx].products.findIndex((product) => product.name === 'Total');

      this.state.dataSource.rows[marginValueIdx].products[totalIdx].value =
        TwoDecimalPlace((planQuotaValue * value) / 100);

      this.state.dataSource.rows[marginValueIdx].products
        .filter((product, idx) => this.state.dataSource.rows[marginValueIdx].products.length - 1 !== idx)
        .forEach((product) => {
          product.value = Math.round(
            (product.oldVal / this.state.dataSource.rows[marginValueIdx].products[totalIdx].oldVal) *
            this.state.dataSource.rows[marginValueIdx].products[totalIdx].value
          );
        });

      this.state.dataSource.rows[marginValueIdx].products.forEach((product) => {
        product.quarters
          .filter((quarter) => !quarter.isPast)
          .forEach((quarter) => {
            quarter.value = quarter.oldVal !== 0
              ? Math.round((quarter.oldVal / product.oldVal) * product.value)
              : 0;
            quarter.isChanged = true;
          });
      });

      this.state.dataSource.rows[rowIdx].products.forEach((product, pIdx: number) => {
        product.quarters
          .filter((quarter) => !quarter.isPast)
          .forEach((quarter, qIdx: number) => {
            const qMarginValue = this.state.dataSource.rows[marginValueIdx].products[pIdx].quarters[qIdx].value;
            const qPlanValue = this.state.dataSource.rows[planValueIdx].products[pIdx].quarters[qIdx].value;
            quarter.value = qPlanValue !== 0 ? TwoDecimalPlace((qMarginValue / qPlanValue) * 100) : 0;
          });
      });

      this.state.dataSource.rows[rowIdx].products
        .filter((product, idx) => this.state.dataSource.rows[rowIdx].products.length - 1 !== idx)
        .forEach((product, pIdx: number) => {
          const pMarginValue = this.state.dataSource.rows[marginValueIdx].products[pIdx].value;
          const pPlanValue = this.state.dataSource.rows[planValueIdx].products[pIdx].value;
          product.value = pPlanValue !== 0 ? TwoDecimalPlace((pMarginValue / pPlanValue) * 100) : 0;
        });
    }

    if (measureGroup === 'Margin $' && productName !== 'Total') {
      /*Update quarters and measure total of Margin $*/
      const productDetails = this.state.dataSource.rows[rowIdx].products[productIdx];
      this.state.dataSource.rows[rowIdx].products[productIdx].quarters
        .filter((quarter) => !quarter.isPast)
        .forEach((quarter) => {
          quarter.value = TwoDecimalPlace((quarter.oldVal / productDetails.oldVal) * productDetails.value);
          quarter.isChanged = true;
        });

      const totalIdx = this.state.dataSource.rows[rowIdx].products.findIndex((product) => product.name === 'Total');
      this.state.dataSource.rows[rowIdx].products[totalIdx].value =
        calculateMeasureTotal(this.state.dataSource.rows[rowIdx].products, measureGroup);
      this.state.dataSource.rows[rowIdx].products[totalIdx].quarters
        .filter((quarter) => !quarter.isPast)
        .forEach((quarter, qIdx: number) => {
          quarter.value = calculateQuarterTotal(this.state.dataSource.rows[rowIdx].products, qIdx, measureGroup);
        });
    }

    if (measureGroup === 'Margin $' && productName === 'Total') {
      const totalIdx = this.state.dataSource.rows[rowIdx].products.findIndex((product) => product.name === 'Total');

      /*Update total of all the products of Margin $*/
      this.state.dataSource.rows[rowIdx].products
        .filter((product, idx) => this.state.dataSource.rows[rowIdx].products.length - 1 !== idx)
        .forEach((product) => {
          product.value = TwoDecimalPlace((product.oldVal / this.state.dataSource.rows[rowIdx].products[totalIdx].oldVal) * value);
        });

      /*Update all the quarters of Margin $*/
      this.state.dataSource.rows[rowIdx].products.forEach((product) => {
        product.quarters
          .filter((quarter) => !quarter.isPast)
          .forEach((quarter) => {
            quarter.value = quarter.oldVal !== 0
              ? TwoDecimalPlace((quarter.oldVal / product.oldVal) * product.value)
              : 0;
            quarter.isChanged = true;
          });
      });
    }

    this.props.UpdateEditRestriction(true);
    this.setState({ dataSource: this.state.dataSource });
  }

  updateQuarterCalculation(
    rowArr,
    rowIdx: number,
    productIdx: number,
    quarterIdx: number,
    measureGroup: string,
    productName: string,
    event
  ): void {
    const value: any = event.target.value !== '' ? parseFloat(event.target.value) : '';

    this.state.dataSource.rows[rowIdx].products[productIdx].quarters[quarterIdx].value = value;
    this.state.dataSource.rows[rowIdx].products[productIdx].quarters[quarterIdx].isEdited = true;
    this.state.dataSource.rows[rowIdx].products[productIdx].quarters[quarterIdx].isChanged = true;

    if (measureGroup === 'Plan / Quota - UNITS' && productName !== 'Total') {
      const planValueIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - $');
      const planAspIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan ASP');
      const planMarginIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Margin $');

      const planQuotaValue = this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].value;
      const planASPValue = this.state.dataSource.rows[planAspIdx].products[productIdx].quarters[quarterIdx].value;

      const planValueTotalIdx = this.state.dataSource.rows[planValueIdx].products.findIndex((product) => product.name === 'Total');
      const totalIdx = this.state.dataSource.rows[rowIdx].products.findIndex((product) => product.name === 'Total');
      const avgIdx = this.state.dataSource.rows[planAspIdx].products.findIndex((product) => product.name === 'Average');
      const marginTotalIdx = this.state.dataSource.rows[planMarginIdx].products.findIndex((product) => product.name === 'Total');

      this.state.dataSource.rows[rowIdx].products[totalIdx].quarters[quarterIdx].value =
        calculateQuarterTotal(this.state.dataSource.rows[rowIdx].products, quarterIdx, measureGroup);
      this.state.dataSource.rows[rowIdx].products[totalIdx].value =
        calculateMeasureTotal(this.state.dataSource.rows[rowIdx].products, measureGroup);
      this.state.dataSource.rows[rowIdx].products.forEach((product) => {
        product.value = calculateEachProductTotal(product.quarters, measureGroup);
      });

      /*edit control for dependent measures*/
      this.state.dataSource.rows[rowIdx].products[productIdx].isDisabled = true;
      this.state.dataSource.rows[planValueIdx].products[productIdx].isDisabled = true;
      this.state.dataSource.rows[planAspIdx].products[productIdx].isDisabled = true;
      this.state.dataSource.rows[planMarginIdx].products[productIdx].isDisabled = true;

      this.state.dataSource.rows[rowIdx].products[totalIdx].isDisabled = true;
      this.state.dataSource.rows[planValueIdx].products[totalIdx].isDisabled = true;
      this.state.dataSource.rows[planAspIdx].products[avgIdx].isDisabled = true;
      //this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].isDisabled = true;
      this.state.dataSource.rows[planMarginIdx].products[marginTotalIdx].isDisabled = true;
      this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].isDisabled = true;

      this.state.dataSource.rows[rowIdx].products[totalIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });
      this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });
      this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });

      const isPlanAspEdited = this.state.dataSource.rows[planAspIdx].products[productIdx].quarters[quarterIdx].isEdited;
      const isPlanValueEdited = this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].isEdited;

      if (isPlanAspEdited) {
        /*Calculation of Plan Quota when UNIT and ASP are edited*/
        const planAspValue = this.state.dataSource.rows[planAspIdx].products[productIdx].quarters[quarterIdx].value;
        this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].value =
          TwoDecimalPlace(value * planAspValue);

        /*Calculation of Plan Quota total when UNIT and ASP are edited*/
        const planUnitTotal = this.state.dataSource.rows[rowIdx].products[totalIdx].quarters[quarterIdx].value;
        const planAspTotal = this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters[quarterIdx].value;

        this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].value =
          TwoDecimalPlace(planUnitTotal * planAspTotal);
        this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].value =
          calculateQuarterTotal(this.state.dataSource.rows[planValueIdx].products, quarterIdx, 'Plan / Quota - $');
        this.state.dataSource.rows[planValueIdx].products[totalIdx].value =
          calculateMeasureTotal(this.state.dataSource.rows[planValueIdx].products, 'Plan / Quota - $');

        this.state.dataSource.rows[planValueIdx].products[productIdx].isDisabled = true;
        this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].isDisabled = true;
      } else if (isPlanValueEdited) {
        /*Calculation of ASP when UNIT and Plan Quota are edited*/
        const planValue = this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].value;
        this.state.dataSource.rows[planAspIdx].products[productIdx].quarters[quarterIdx].value =
          value !== 0 ? TwoDecimalPlace(planValue / value) : 0;

        /*Calculation of ASP total when UNIT and Plan Quota are edited*/
        const planUnitQuarterTotal = this.state.dataSource.rows[rowIdx].products[totalIdx].quarters[quarterIdx].value;
        const planValueQuarterTotal = this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].value;
        const planUnitTotal = this.state.dataSource.rows[rowIdx].products[totalIdx].value;
        const planValueTotal = this.state.dataSource.rows[planValueIdx].products[totalIdx].value;

        this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters[quarterIdx].value =
          planUnitQuarterTotal !== 0 ? TwoDecimalPlace(planValueQuarterTotal / planUnitQuarterTotal) : 0;
        this.state.dataSource.rows[planAspIdx].products[avgIdx].value =
          planUnitTotal !== 0 ? TwoDecimalPlace(planValueTotal / planUnitTotal) : 0;
        this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters[quarterIdx].value =
          planUnitQuarterTotal !== 0 ? TwoDecimalPlace(planValueQuarterTotal / planUnitQuarterTotal) : 0;

        this.state.dataSource.rows[planAspIdx].products[productIdx].isDisabled = true;
        this.state.dataSource.rows[planAspIdx].products[productIdx].quarters[quarterIdx].isDisabled = true;
      } else {

        //Calculate Margin % from old Sales and Margin $ value
        const oldPlanValue = this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].oldVal;
        const oldMarginValue = this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].oldVal;
        const planMarginPctValue = (oldMarginValue / oldPlanValue) * 100;

        this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].value =
          TwoDecimalPlace(planASPValue * value);
        this.state.dataSource.rows[planValueIdx].products[productIdx].value =
          calculateEachProductTotal(this.state.dataSource.rows[planValueIdx].products[productIdx].quarters, 'Plan / Quota - $');

        this.state.dataSource.rows[planValueIdx].products[planValueTotalIdx].quarters[quarterIdx].value =
          calculateQuarterTotal(this.state.dataSource.rows[planValueIdx].products, quarterIdx, 'Plan / Quota - $');
        this.state.dataSource.rows[planValueIdx].products[planValueTotalIdx].value = calculateEachProductTotal(this.state.dataSource.rows[planValueIdx].products[planValueTotalIdx].quarters, 'Plan / Quota - $');
        this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].isChanged = true;

        //Caluclate Margin $ Value
        const newSalesPlanValue = this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].value;
        this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].value =
          TwoDecimalPlace(newSalesPlanValue * (planMarginPctValue / 100));
        this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].isChanged = true;

        //Calculate Margin $ Quarter's Total
        this.state.dataSource.rows[planMarginIdx].products[totalIdx].quarters[quarterIdx].value =
          calculateQuarterTotal(this.state.dataSource.rows[planMarginIdx].products, quarterIdx, 'Margin $');

        //Calculate Margin $ Product's Total
        this.state.dataSource.rows[planMarginIdx].products[productIdx].value =
          calculateEachProductTotal(this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters, 'Margin $');

        //Calculate Margin $ GrandTotal's Total
        this.state.dataSource.rows[planMarginIdx].products[marginTotalIdx].value =
          calculateEachProductTotal(this.state.dataSource.rows[planMarginIdx].products[marginTotalIdx].quarters, 'Margin $');
      }
    }

    if (measureGroup === 'Plan / Quota - UNITS' && productName === 'Total') {
      const measureIdx = this.state.dataSource.rows.findIndex((row) => row.name === measureGroup);
      const planMarginIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Margin $');

      const totalIdx = this.state.dataSource.rows[rowIdx].products.findIndex((product) => product.name === 'Total');
      const marginTotalIdx = this.state.dataSource.rows[planMarginIdx].products.findIndex((product) => product.name === 'Total');

      this.state.dataSource.rows[measureIdx].products
        .filter((product) => product.name !== 'Total')
        .forEach((product, pIdx) => {

          //Calulate Unit Value
          product.quarters[quarterIdx].value =
            Math.round(
              (product.quarters[quarterIdx].oldVal /
                this.state.dataSource.rows[measureIdx].products[totalIdx].quarters[quarterIdx].oldVal)
              * value
            );
          product.quarters[quarterIdx].isChanged = true;
        });
      this.state.dataSource.rows[rowIdx].products.forEach((product) => {
        product.value = calculateEachProductTotal(product.quarters, measureGroup);
      });

      /*edit control for dependent measures*/
      const planValueIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - $');
      const planAspIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan ASP');
      const avgIdx = this.state.dataSource.rows[planAspIdx].products.findIndex((product) => product.name === 'Average');

      this.state.dataSource.rows[rowIdx].products[totalIdx].isDisabled = true;
      this.state.dataSource.rows[planValueIdx].products[totalIdx].isDisabled = true;
      this.state.dataSource.rows[planAspIdx].products[avgIdx].isDisabled = true;

      this.state.dataSource.rows[rowIdx].products
        .filter((product, pIdx: number) => this.state.dataSource.rows[rowIdx].products.length - 1 !== pIdx)
        .forEach((product) => {
          product.isDisabled = true;
          product.quarters.forEach((quarter) => {
            quarter.isDisabled = true;
          });
        });
      this.state.dataSource.rows[planValueIdx].products
        .filter((product, pIdx: number) => this.state.dataSource.rows[planValueIdx].products.length - 1 !== pIdx)
        .forEach((product) => {
          product.isDisabled = true;
          product.quarters.forEach((quarter) => {
            quarter.isDisabled = true;
          });
        });
      this.state.dataSource.rows[planAspIdx].products
        .filter((product, pIdx: number) => this.state.dataSource.rows[planAspIdx].products.length - 1 !== pIdx)
        .forEach((product) => {
          product.isDisabled = true;
          product.quarters.forEach((quarter) => {
            quarter.isDisabled = true;
          });
        });

      const isPlanAspEdited = this.state.dataSource.rows[planAspIdx].products[totalIdx].quarters[quarterIdx].isEdited;
      const isPlanValueEdited = this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].isEdited;

      if (isPlanAspEdited) {
        const planAspQuarterTotal = this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters[quarterIdx].value;
        this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].value =
          TwoDecimalPlace(value * planAspQuarterTotal);

        this.state.dataSource.rows[planValueIdx].products
          .filter((product) => product.name !== 'Total')
          .forEach((product) => {
            product.quarters[quarterIdx].value =
              Math.round(
                (product.quarters[quarterIdx].oldVal /
                  this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].oldVal)
                * TwoDecimalPlace(value * planAspQuarterTotal)
              );
            product.quarters[quarterIdx].isChanged = true;
          });
        this.state.dataSource.rows[planValueIdx].products.forEach((product) => {
          product.value = calculateEachProductTotal(product.quarters, 'Plan / Quota - $');
        });

        this.state.dataSource.rows[planValueIdx].products[totalIdx].isDisabled = true;
        this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].isDisabled = true;
      } else if (isPlanValueEdited) {
        const planValueQuarterTotal = this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].value;
        this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters[quarterIdx].value =
          value !== 0 ? TwoDecimalPlace(planValueQuarterTotal / value) : 0;

        this.state.dataSource.rows[planAspIdx].products
          .filter((product, idx) => this.state.dataSource.rows[planAspIdx].products.length - 1 !== idx)
          .forEach((product, pIdx: number) => {
            product.quarters[quarterIdx].value =
              calculateQuarterValue(rowArr, planAspIdx, pIdx, quarterIdx, 'Plan ASP');
          });
        this.state.dataSource.rows[planAspIdx].products.forEach((product, pIdx: number) => {
          product.value = calculateProductTotal(rowArr, planAspIdx, pIdx, 'Plan ASP');
        });

        this.state.dataSource.rows[planAspIdx].products[totalIdx].isDisabled = true;
        this.state.dataSource.rows[planAspIdx].products[totalIdx].quarters[quarterIdx].isDisabled = true;
      } else {
        const planValueTotalIdx = this.state.dataSource.rows[planValueIdx].products.findIndex((product) => product.name === 'Total');
        this.state.dataSource.rows[planValueIdx].products[planValueTotalIdx].quarters[quarterIdx].value = TwoDecimalPlace(value * this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters[quarterIdx].value);
        this.state.dataSource.rows[planValueIdx].products
          .filter((product) => (product.name !== 'Total'))
          .forEach((product, pIdx: number) => {

            const unitValue = this.state.dataSource.rows[rowIdx].products[pIdx].quarters[quarterIdx].value;
            const aspValue = this.state.dataSource.rows[planAspIdx].products[pIdx].quarters[quarterIdx].value;
            product.quarters[quarterIdx].value =
              TwoDecimalPlace((product.quarters[quarterIdx].oldVal / this.state.dataSource.rows[planValueIdx].products[planValueTotalIdx].oldVal) * this.state.dataSource.rows[planValueIdx].products[planValueTotalIdx].quarters[quarterIdx].value);
            //TwoDecimalPlace(unitValue * aspValue);
            product.quarters[quarterIdx].isChanged = true;


            //Calulate Margin % for Each Product from old Margin $ and old Sales Value
            const oldMarginValue = this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].oldVal;
            const oldSalesValue = product.quarters[quarterIdx].oldVal;
            const oldMarginPctValue = (oldMarginValue / oldSalesValue) * 100;

            //Calculate Margin $
            const newSalesValue = product.quarters[quarterIdx].value;
            this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].value = TwoDecimalPlace(newSalesValue * (oldMarginPctValue / 100));
            this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].isChanged = true;
            this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].isDisabled = true;
          });

        //this.state.dataSource.rows[planValueIdx].products[planValueTotalIdx].quarters[quarterIdx].value =
        //calculateQuarterTotal(this.state.dataSource.rows[planValueIdx].products, quarterIdx, 'Plan / Quota - $');

        this.state.dataSource.rows[planValueIdx].products[planValueTotalIdx].value =
          calculateEachProductTotal(this.state.dataSource.rows[planValueIdx].products[productIdx].quarters, 'Plan / Quota - $');

        this.state.dataSource.rows[planValueIdx].products.forEach((product, pIdx: number) => {
          product.value = calculateProductTotal(rowArr, planValueIdx, pIdx, 'Plan / Quota - $');
        });

        //Calculate Margin $ Quarter's Total
        this.state.dataSource.rows[planMarginIdx].products[totalIdx].quarters[quarterIdx].value =
          calculateQuarterTotal(this.state.dataSource.rows[planMarginIdx].products, quarterIdx, 'Margin $');

        //Calculate Margin $ Product's Total
        this.state.dataSource.rows[planMarginIdx].products.forEach((product, pIdx) => {
          product.value = calculateProductTotal(rowArr, planMarginIdx, pIdx, 'Margin $');
        });

        //Calculate Margin $ GrandTotal's Total
        this.state.dataSource.rows[planMarginIdx].products[marginTotalIdx].value =
          calculateEachProductTotal(this.state.dataSource.rows[planMarginIdx].products[marginTotalIdx].quarters, 'Margin $');
      }
    }

    if (measureGroup === 'Plan / Quota - $' && productName !== 'Total') {
      const planUnitIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - UNITS');
      const planAspIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan ASP');
      const planQuotaIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - $');
      const planMarginIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Margin $');

      const totalIdx = this.state.dataSource.rows[rowIdx].products.findIndex((product) => product.name === 'Total');
      const avgIdx = this.state.dataSource.rows[planAspIdx].products.findIndex((product) => product.name === 'Average');
      const marginTotalIdx = this.state.dataSource.rows[planMarginIdx].products.findIndex((product) => product.name === 'Total');

      //Calculate old Margin pct
      const oldPlanMarginValue = this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].oldVal;
      const oldSalesValue = this.state.dataSource.rows[planQuotaIdx].products[productIdx].quarters[quarterIdx].oldVal;
      const oldMarginPctValue = (oldPlanMarginValue / oldSalesValue) * 100;

      this.state.dataSource.rows[rowIdx].products[totalIdx].quarters[quarterIdx].value =
        calculateQuarterTotal(this.state.dataSource.rows[rowIdx].products, quarterIdx, measureGroup);
      this.state.dataSource.rows[rowIdx].products[totalIdx].value =
        calculateMeasureTotal(this.state.dataSource.rows[rowIdx].products, measureGroup);
      this.state.dataSource.rows[rowIdx].products.forEach((product) => {
        product.value = calculateEachProductTotal(product.quarters, measureGroup);
      });

      /*edit control for dependent measures*/
      this.state.dataSource.rows[planUnitIdx].products[productIdx].isDisabled = true;
      this.state.dataSource.rows[rowIdx].products[productIdx].isDisabled = true;
      this.state.dataSource.rows[planAspIdx].products[productIdx].isDisabled = true;

      this.state.dataSource.rows[planUnitIdx].products[totalIdx].isDisabled = true;
      this.state.dataSource.rows[rowIdx].products[totalIdx].isDisabled = true;
      this.state.dataSource.rows[planAspIdx].products[avgIdx].isDisabled = true;
      // this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].isDisabled = true;

      this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });
      this.state.dataSource.rows[rowIdx].products[totalIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });
      this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });

      const isPlanAspEdited = this.state.dataSource.rows[planAspIdx].products[productIdx].quarters[quarterIdx].isEdited;
      const isPlanUnitEdited = this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].isEdited;

      if (isPlanAspEdited) {
        /*Calculation of UNIT when Plan Quota and ASP are edited*/
        const planAspValue = this.state.dataSource.rows[planAspIdx].products[productIdx].quarters[quarterIdx].value;
        this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].value =
          planAspValue !== 0 ? Math.round(value / planAspValue) : 0;

        /*Calculation of UNIT total when Plan Quota and ASP are edited*/
        const planValueTotal = this.state.dataSource.rows[rowIdx].products[totalIdx].quarters[quarterIdx].value;
        const planAspTotal = this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters[quarterIdx].value;

        this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].value =
          planAspTotal !== 0 ? Math.round(planValueTotal / planAspTotal) : 0;
        this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].value =
          calculateQuarterTotal(this.state.dataSource.rows[planUnitIdx].products, quarterIdx, 'Plan / Quota - UNITS');
        this.state.dataSource.rows[planUnitIdx].products[totalIdx].value =
          calculateMeasureTotal(this.state.dataSource.rows[planUnitIdx].products, 'Plan / Quota - UNITS');

        this.state.dataSource.rows[planUnitIdx].products[productIdx].isDisabled = true;
        this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].isDisabled = true;
      } else if (isPlanUnitEdited) {
        /*Calculation of ASP when Plan Quota and UNIT are edited*/
        const planUnitValue = this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].value;
        this.state.dataSource.rows[planAspIdx].products[productIdx].quarters[quarterIdx].value =
          planUnitValue !== 0 ? TwoDecimalPlace(value / planUnitValue) : 0;

        /*Calculation of ASP total when Plan Quota and UNIT are edited*/
        const planValueTotal = this.state.dataSource.rows[rowIdx].products[totalIdx].quarters[quarterIdx].value;
        const planUnitTotal = this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].value;

        this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters[quarterIdx].value =
          planUnitTotal !== 0 ? TwoDecimalPlace(planValueTotal / planUnitTotal) : 0;
        this.state.dataSource.rows[planAspIdx].products[avgIdx].value =
          planUnitTotal !== 0 ? TwoDecimalPlace(planValueTotal / planUnitTotal) : 0;

        this.state.dataSource.rows[planAspIdx].products[productIdx].isDisabled = true;
        this.state.dataSource.rows[planAspIdx].products[productIdx].quarters[quarterIdx].isDisabled = true;
      } else {
        /*Calculation of UNIT when Plan Quota and ASP are edited*/
        this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].isChanged = true;
        const planAspValue = this.state.dataSource.rows[planAspIdx].products[productIdx].quarters[quarterIdx].value;
        this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].value =
          planAspValue !== 0 ? Math.round(value / planAspValue) : 0;
        this.state.dataSource.rows[planUnitIdx].products.forEach((product) => {
          product.value = calculateEachProductTotal(product.quarters, measureGroup);
        });

        /*Calculation of UNIT total when Plan Quota and ASP are edited*/
        const planValueTotal = this.state.dataSource.rows[rowIdx].products[totalIdx].quarters[quarterIdx].value;
        const planAspTotal = this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters[quarterIdx].value;

        this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].value =
          planValueTotal !== 0 ? Math.round(planValueTotal / planAspTotal) : 0;
        this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].value =
          calculateQuarterTotal(this.state.dataSource.rows[planUnitIdx].products, quarterIdx, 'Plan / Quota - UNITS');
        this.state.dataSource.rows[planUnitIdx].products[totalIdx].value =
          calculateMeasureTotal(this.state.dataSource.rows[planUnitIdx].products, 'Plan / Quota - UNITS');
        this.state.dataSource.rows[planQuotaIdx].products[totalIdx].quarters[quarterIdx].value =
          calculateQuarterTotal(this.state.dataSource.rows[planQuotaIdx].products, quarterIdx, 'Plan / Quota - $');

        // Calcuclate Margin $ Value
        const newSalesPlanValue = this.state.dataSource.rows[planQuotaIdx].products[productIdx].quarters[quarterIdx].value;
        this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].value =
          TwoDecimalPlace(newSalesPlanValue * (oldMarginPctValue / 100));
        this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].isChanged = true;
        this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].isDisabled = true;

        //Calculate Margin $ Quarter's Total
        this.state.dataSource.rows[planMarginIdx].products[totalIdx].quarters[quarterIdx].value =
          calculateQuarterTotal(this.state.dataSource.rows[planMarginIdx].products, quarterIdx, 'Margin $');

        //Calculate Margin $ Product's Total
        this.state.dataSource.rows[planMarginIdx].products[productIdx].value =
          calculateEachProductTotal(this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters, 'Margin $');

        //Calculate Margin $ GrandTotal's Total
        this.state.dataSource.rows[planMarginIdx].products[marginTotalIdx].value =
          calculateEachProductTotal(this.state.dataSource.rows[planMarginIdx].products[marginTotalIdx].quarters, 'Margin $');
      }
    }

    if (measureGroup === 'Plan / Quota - $' && productName === 'Total') {
      const measureIdx = this.state.dataSource.rows.findIndex((row) => row.name === measureGroup);
      const planMarginIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Margin $');

      const totalIdx = this.state.dataSource.rows[rowIdx].products.findIndex((product) => product.name === 'Total');
      const marginTotalIdx = this.state.dataSource.rows[planMarginIdx].products.findIndex((product) => product.name === 'Total');

      this.state.dataSource.rows[measureIdx].products
        .filter((product) => product.name !== 'Total')
        .forEach((product, pIdx) => {

          //Calulate Margin % for Each Product from old Margin $ and old Sales Value
          const oldMarginValue = this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].oldVal;
          const oldSalesValue = product.quarters[quarterIdx].oldVal;
          const oldMarginPctValue = (oldMarginValue / oldSalesValue) * 100;

          //Calculate Sales Value
          product.quarters[quarterIdx].value =
            TwoDecimalPlace(
              (product.quarters[quarterIdx].oldVal /
                this.state.dataSource.rows[measureIdx].products[totalIdx].quarters[quarterIdx].oldVal)
              * value
            );
          product.quarters[quarterIdx].isChanged = true;

          //Calculate Margin $
          const newSalesValue = product.quarters[quarterIdx].value;
          this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].value = TwoDecimalPlace(newSalesValue * (oldMarginPctValue / 100));
          this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].isChanged = true;
          this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].isDisabled = true;

        });

      //Calculate Margin $ Quarter's Total
      this.state.dataSource.rows[planMarginIdx].products[totalIdx].quarters[quarterIdx].value =
        calculateQuarterTotal(this.state.dataSource.rows[planMarginIdx].products, quarterIdx, 'Margin $');
      this.state.dataSource.rows[planMarginIdx].products[totalIdx].quarters[quarterIdx].isDisabled = true;

      //Calculate Margin $ Product's Total
      this.state.dataSource.rows[planMarginIdx].products.forEach((product, pIdx) => {
        product.value = calculateProductTotal(rowArr, planMarginIdx, pIdx, 'Margin $');
        product.isDisabled = true;
      });

      this.state.dataSource.rows[rowIdx].products.forEach((product) => {
        product.value = calculateEachProductTotal(product.quarters, measureGroup);
      });

      const planAspIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan ASP');
      const avgIdx = this.state.dataSource.rows[planAspIdx].products.findIndex((product) => product.name === 'Average');
      const planUnitIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - UNITS');

      /*edit control for dependent measures*/
      this.state.dataSource.rows[planUnitIdx].products[totalIdx].isDisabled = true;
      this.state.dataSource.rows[rowIdx].products[totalIdx].isDisabled = true;
      this.state.dataSource.rows[planAspIdx].products[avgIdx].isDisabled = true;

      this.state.dataSource.rows[planUnitIdx].products
        .filter((product, pIdx: number) => this.state.dataSource.rows[planUnitIdx].products.length - 1 !== pIdx)
        .forEach((product) => {
          product.isDisabled = true;
          product.quarters.forEach((quarter) => {
            quarter.isDisabled = true;
          });
        });
      this.state.dataSource.rows[rowIdx].products
        .filter((product, pIdx: number) => this.state.dataSource.rows[rowIdx].products.length - 1 !== pIdx)
        .forEach((product) => {
          product.isDisabled = true;
          product.quarters.forEach((quarter) => {
            quarter.isDisabled = true;
          });
        });
      this.state.dataSource.rows[planAspIdx].products
        .filter((product, pIdx: number) => this.state.dataSource.rows[planAspIdx].products.length - 1 !== pIdx)
        .forEach((product) => {
          product.isDisabled = true;
          product.quarters.forEach((quarter) => {
            quarter.isDisabled = true;
          });
        });

      const isPlanAspEdited = this.state.dataSource.rows[planAspIdx].products[totalIdx].quarters[quarterIdx].isEdited;
      const isPlanUnitEdited = this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].isEdited;

      if (isPlanAspEdited) {
        const planAspQuarterTotal = this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters[quarterIdx].value;
        this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].value =
          planAspQuarterTotal !== 0 ? Math.round(value / planAspQuarterTotal) : 0;

        this.state.dataSource.rows[planUnitIdx].products
          .filter((product) => product.name !== 'Total')
          .forEach((product) => {
            product.quarters[quarterIdx].value =
              Math.round(
                (product.quarters[quarterIdx].oldVal /
                  this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].oldVal)
                * Math.round(value / planAspQuarterTotal)
              );
            product.quarters[quarterIdx].isChanged = true;
          });
        this.state.dataSource.rows[planUnitIdx].products.forEach((product) => {
          product.value = calculateEachProductTotal(product.quarters, 'Plan / Quota - UNITS');
        });

        this.state.dataSource.rows[planUnitIdx].products[totalIdx].isDisabled = true;
        this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].isDisabled = true;
      } else if (isPlanUnitEdited) {
        this.state.dataSource.rows[planAspIdx].products.forEach((product, pIdx: number) => {
          product.quarters[quarterIdx].value =
            calculateQuarterValue(rowArr, planAspIdx, pIdx, quarterIdx, 'Plan ASP');
        });
        this.state.dataSource.rows[planAspIdx].products.forEach((product, pIdx: number) => {
          product.value = calculateProductTotal(rowArr, planAspIdx, pIdx, 'Plan ASP');
        });

        this.state.dataSource.rows[planAspIdx].products.forEach((product, pIdx: number) => {
          const planUnitValue = this.state.dataSource.rows[planUnitIdx].products[pIdx].value;
          product.value = planUnitValue !== 0 ? TwoDecimalPlace(value / planUnitValue) : 0;
        });

        this.state.dataSource.rows[planAspIdx].products.forEach((product, pIdx: number) => {
          product.quarters.forEach((quarter, qIdx: number) => {
            quarter.value = calculateQuarterValue(rowArr, planAspIdx, pIdx, qIdx, 'Plan ASP');
          });
        });

        this.state.dataSource.rows[planAspIdx].products[totalIdx].isDisabled = true;
        this.state.dataSource.rows[planAspIdx].products[totalIdx].quarters[quarterIdx].isDisabled = true;
      } else {
        const planAspQuarterTotal = this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters[quarterIdx].value;
        this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].value =
          planAspQuarterTotal !== 0 ? Math.round(value / planAspQuarterTotal) : 0;

        this.state.dataSource.rows[planUnitIdx].products
          .filter((product) => product.name !== 'Total')
          .forEach((product) => {
            product.quarters[quarterIdx].value =
              Math.round(
                (product.quarters[quarterIdx].oldVal /
                  this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].oldVal)
                * Math.round(value / planAspQuarterTotal)
              );
            product.quarters[quarterIdx].isChanged = true;
          });
        this.state.dataSource.rows[planUnitIdx].products.forEach((product) => {
          product.value = calculateEachProductTotal(product.quarters, 'Plan / Quota - UNITS');
        });
      }
    }

    if (measureGroup === 'Plan ASP' && productName !== 'Average') {
      const planUnitIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - UNITS');
      const planValueIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - $');
      const planMarginIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Margin $');

      const planQuotaValue = this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].value;
      const planUnitValue = this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].value;

      this.state.dataSource.rows[rowIdx].products[productIdx].quarters[quarterIdx].isChanged = false;

      const totalSalesIdx = this.state.dataSource.rows[planValueIdx].products.findIndex((product) => product.name === 'Total');
      const totalIdx = this.state.dataSource.rows[planUnitIdx].products.findIndex((product) => product.name === 'Total');
      const avgIdx = this.state.dataSource.rows[rowIdx].products.findIndex((product) => product.name === 'Average');
      const marginTotalIdx = this.state.dataSource.rows[planMarginIdx].products.findIndex((product) => product.name === 'Total');

      /*edit control for dependent measures*/
      this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].isChanged = true;
      //this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].isChanged = true;

      this.state.dataSource.rows[planUnitIdx].products[productIdx].isDisabled = true;
      this.state.dataSource.rows[planValueIdx].products[productIdx].isDisabled = true;
      this.state.dataSource.rows[rowIdx].products[productIdx].isDisabled = true;

      this.state.dataSource.rows[planUnitIdx].products[totalIdx].isDisabled = true;
      this.state.dataSource.rows[planValueIdx].products[totalIdx].isDisabled = true;
      this.state.dataSource.rows[rowIdx].products[avgIdx].isDisabled = true;

      // this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].isDisabled = true;

      this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });
      this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });
      this.state.dataSource.rows[rowIdx].products[avgIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });

      const isPlanValueEdited = this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].isEdited;
      const isPlanUnitEdited = this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].isEdited;

      if (isPlanValueEdited) {
        /*Calculation of Plan Quota Value when ASP and Plan Quota are edited*/
        const planUnitValue = this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].value; 
        this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].value =
          value !== 0 ? TwoDecimalPlace(planUnitValue/value) : 0;

        /*Calculation of UNIT total when ASP and Plan Quota are edited*/
        const planValueTotal = this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].value;
        const planAspTotal = this.state.dataSource.rows[rowIdx].products[avgIdx].quarters[quarterIdx].value;
        const planUnitTotal = this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].value;

        this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].value =
          planAspTotal !== 0 ? TwoDecimalPlace(planValueTotal / planAspTotal) : 0;
        this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].value =
          calculateQuarterTotal(this.state.dataSource.rows[planValueIdx].products, quarterIdx, 'Plan / Quota - UNITS');
        this.state.dataSource.rows[planValueIdx].products[totalIdx].value =
          calculateMeasureTotal(this.state.dataSource.rows[planValueIdx].products, 'Plan / Quota - UNITS');

        this.state.dataSource.rows[planValueIdx].products[productIdx].isDisabled = true;
        // this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].isDisabled = true;
      } else if (isPlanUnitEdited) {
        /*Calculation of Plan Quota when ASP and UNIT are edited*/
        const planUnitValue = this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].value;
        this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].value =
          TwoDecimalPlace(planUnitValue * value);

        /*Calculation of Plan Quota total when ASP and UNIT are edited*/
        const planUnitTotal = this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].value;
        const planAspTotal = this.state.dataSource.rows[rowIdx].products[avgIdx].quarters[quarterIdx].value;

        this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].value =
          TwoDecimalPlace(planUnitTotal * planAspTotal);
        this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].value =
          calculateQuarterTotal(this.state.dataSource.rows[planValueIdx].products, quarterIdx, 'Plan / Quota - $');
        this.state.dataSource.rows[planValueIdx].products[totalIdx].value =
          calculateMeasureTotal(this.state.dataSource.rows[planValueIdx].products, 'Plan / Quota - $');

        this.state.dataSource.rows[planValueIdx].products[productIdx].isDisabled = true;
        this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].isDisabled = true;
      } else {
        //Calulate Margin % for Each Product from old Margin $ and old Sales Value
        const oldMarginValue = this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].oldVal;
        const oldSalesValue = this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].oldVal;
        const oldMarginPctValue = (oldMarginValue / oldSalesValue) * 100;

        this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].value = TwoDecimalPlace(planUnitValue * value);

        this.state.dataSource.rows[planValueIdx].products[productIdx].value =
          calculateEachProductTotal(
            this.state.dataSource.rows[planValueIdx].products[productIdx].quarters,
            'Plan / Quota - $'
          );

        this.state.dataSource.rows[planValueIdx].products[totalSalesIdx].quarters[quarterIdx].value =
          calculateQuarterTotal(this.state.dataSource.rows[planValueIdx].products, quarterIdx, 'Plan / Quota - $');
        this.state.dataSource.rows[planValueIdx].products[totalSalesIdx].value =
          calculateMeasureTotal(this.state.dataSource.rows[planValueIdx].products, 'Plan / Quota - $');

        //Caluclate Margin $ Value
        const newSalesPlanValue = this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].value;
        this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].value =
          TwoDecimalPlace(newSalesPlanValue * (oldMarginPctValue / 100));
        this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].isChanged = true;
        this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].isDisabled = true;

        //Calculate Margin $ Quarter's Total
        this.state.dataSource.rows[planMarginIdx].products[totalIdx].quarters[quarterIdx].value =
          calculateQuarterTotal(this.state.dataSource.rows[planMarginIdx].products, quarterIdx, 'Margin $');

        this.state.dataSource.rows[planMarginIdx].products[totalIdx].quarters[quarterIdx].isDisabled = true;

        //Calculate Margin $ Product's Total
        this.state.dataSource.rows[planMarginIdx].products[productIdx].value =
          calculateEachProductTotal(this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters, 'Margin $');

        //Calculate Margin $ GrandTotal's Total
        this.state.dataSource.rows[planMarginIdx].products[marginTotalIdx].value =
          calculateEachProductTotal(this.state.dataSource.rows[planMarginIdx].products[marginTotalIdx].quarters, 'Margin $');


        // Calculate Average of each quarter
        this.state.dataSource.rows[rowIdx].products[avgIdx].quarters
          .filter((quarter) => !quarter.isPast)
          .forEach((quarter) => {
            this.state.dataSource.rows[planValueIdx].products[totalSalesIdx].quarters
              .filter((valquarter) => !valquarter.isPast && valquarter.name == quarter.name)
              .forEach((valquarter) => {
                this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters
                  .filter((unitquarter) => !unitquarter.isPast && unitquarter.name == quarter.name)
                  .forEach((unitquarter) => {
                    const qValue = valquarter.value;
                    const qUnit = unitquarter.value;
                    quarter.value = qUnit !== 0 ? TwoDecimalPlace(qValue / qUnit) : 0;

                  });

              });

          });

        this.state.dataSource.rows[rowIdx].products[productIdx].value =
          TwoDecimalPlace(
            this.state.dataSource.rows[planValueIdx].products[productIdx].value /
            this.state.dataSource.rows[planUnitIdx].products[productIdx].value
          );

        this.state.dataSource.rows[rowIdx].products[avgIdx].value =
          TwoDecimalPlace(
            this.state.dataSource.rows[planValueIdx].products[totalIdx].value /
            this.state.dataSource.rows[planUnitIdx].products[totalIdx].value
          );

      }
    }

    if (measureGroup === 'Plan ASP' && productName === 'Average') {
      const planUnitIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - UNITS');
      const planValueIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - $');
      const planMarginIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Margin $');
      const planAspIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan ASP');

      const planQuotaValue = this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].value;
      const planUnitValue = this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].value;

      this.state.dataSource.rows[rowIdx].products[productIdx].quarters[quarterIdx].isChanged = false;

      const totalIdx = this.state.dataSource.rows[planUnitIdx].products.findIndex((product) => product.name === 'Total');
      const marginTotalIdx = this.state.dataSource.rows[planMarginIdx].products.findIndex((product) => product.name === 'Total');
      const avgIdx = this.state.dataSource.rows[planAspIdx].products.findIndex((product) => product.name === 'Average');

      /*this.state.dataSource.rows[rowIdx].products.forEach((product) => {
        product.value = calculateEachProductTotal(product.quarters, measureGroup);
      });



      this.state.dataSource.rows[rowIdx].products
        .filter((product, idx) => this.state.dataSource.rows[rowIdx].products.length - 1 !== idx)
        .forEach((product, pIdx: number) => {
          product.quarters[quarterIdx].value =
            calculateQuarterValue(rowArr, rowIdx, pIdx, quarterIdx, measureGroup);
        });
      this.state.dataSource.rows[rowIdx].products.forEach((product, pIdx: number) => {
        product.value = calculateProductTotal(rowArr, rowIdx, pIdx, measureGroup);
      });
      */
      /*edit control for dependent measures*/
      this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].isChanged = true;

      this.state.dataSource.rows[planUnitIdx].products[totalIdx].isDisabled = true;
      this.state.dataSource.rows[planValueIdx].products[totalIdx].isDisabled = true;
      this.state.dataSource.rows[rowIdx].products[productIdx].isDisabled = true;

      this.state.dataSource.rows[planUnitIdx].products
        .filter((product, pIdx: number) => this.state.dataSource.rows[planUnitIdx].products.length - 1 !== pIdx)
        .forEach((product) => {
          product.isDisabled = true;
          product.quarters.forEach((quarter) => {
            quarter.isDisabled = true;
          });
        });
      this.state.dataSource.rows[planValueIdx].products
        .filter((product, pIdx: number) => this.state.dataSource.rows[planValueIdx].products.length - 1 !== pIdx)
        .forEach((product) => {
          product.isDisabled = true;
          product.quarters.forEach((quarter) => {
            quarter.isDisabled = true;
          });
        });
      this.state.dataSource.rows[rowIdx].products
        .filter((product, pIdx: number) => this.state.dataSource.rows[rowIdx].products.length - 1 !== pIdx)
        .forEach((product) => {
          product.isDisabled = true;
          product.quarters.forEach((quarter) => {
            quarter.isDisabled = true;
          });
        });

      const isPlanValueEdited = this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].isEdited;
      const isPlanUnitEdited = this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].isEdited;

      if (isPlanValueEdited) {
        const planValueQuarterTotal = this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].value;
        this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].value =
          value !== 0 ? Math.round(planValueQuarterTotal / value) : 0;

        this.state.dataSource.rows[planUnitIdx].products
          .filter((product) => product.name !== 'Total')
          .forEach((product) => {
            product.quarters[quarterIdx].value =
              Math.round(
                (product.quarters[quarterIdx].oldVal /
                  this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].oldVal)
                * Math.round(planValueQuarterTotal / value)
              );
            product.quarters[quarterIdx].isChanged = true;
          });
        this.state.dataSource.rows[planUnitIdx].products.forEach((product) => {
          product.value = calculateEachProductTotal(product.quarters, 'Plan / Quota - UNITS');
        });

        this.state.dataSource.rows[planUnitIdx].products[totalIdx].isDisabled = true;
        this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].isDisabled = true;
      } else if (isPlanUnitEdited) {
        const planUnitValue = this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].value;
        this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].value =
          TwoDecimalPlace(planUnitValue * value);

        this.state.dataSource.rows[planValueIdx].products
          .filter((product) => product.name !== 'Total')
          .forEach((product) => {
            const oldTotalValue = this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].oldVal;
            const newTotalValue = this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].value;
            product.quarters[quarterIdx].value =
              TwoDecimalPlace((product.quarters[quarterIdx].oldVal / oldTotalValue) * newTotalValue);
            product.quarters[quarterIdx].isChanged = true;
          });
        this.state.dataSource.rows[planValueIdx].products.forEach((product) => {
          product.value = calculateEachProductTotal(product.quarters, 'Plan / Quota - $');
        });

        this.state.dataSource.rows[planValueIdx].products[totalIdx].isDisabled = true;
        this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].isDisabled = true;
      } else {
        this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].value =
          TwoDecimalPlace(planUnitValue * value);

        this.state.dataSource.rows[planValueIdx].products
          .filter((product) => product.name !== 'Total')
          .forEach((product, pIdx) => {

            //Calulate Margin % for Each Product from old Margin $ and old Sales Value
            const oldMarginValue = this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].oldVal;
            const oldSalesValue = product.quarters[quarterIdx].oldVal;
            const oldMarginPctValue = (oldMarginValue / oldSalesValue) * 100;

            //Calulate Sales Value
            product.quarters[quarterIdx].value =
              TwoDecimalPlace(
                (product.quarters[quarterIdx].oldVal /
                  this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].oldVal)
                * this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].value
              );
            product.quarters[quarterIdx].isChanged = true;

            //Calculate Margin $
            const newSalesValue = product.quarters[quarterIdx].value;
            this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].value = TwoDecimalPlace(newSalesValue * (oldMarginPctValue / 100));
            this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].isChanged = true;
            this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].isDisabled = true;

          });

        this.state.dataSource.rows[planValueIdx].products[totalIdx].value =
          calculateEachProductTotal(this.state.dataSource.rows[planValueIdx].products[productIdx].quarters, 'Plan / Quota - $');

        this.state.dataSource.rows[planValueIdx].products.forEach((product, pIdx: number) => {
          product.value = calculateProductTotal(rowArr, planValueIdx, pIdx, 'Plan / Quota - $');
        });

        // Calculate Average of each Quarter
        this.state.dataSource.rows[rowIdx].products
          .filter((product) => product.name !== 'Total')
          .forEach((product) => {
            this.state.dataSource.rows[planValueIdx].products
              .filter((valproduct) => valproduct.name == product.name)
              .forEach((valproduct) => {
                this.state.dataSource.rows[planUnitIdx].products
                  .filter((unitproduct) => unitproduct.name == product.name)
                  .forEach((unitproduct) => {
                    const qValue = valproduct.quarters[quarterIdx].value;
                    const qUnit = unitproduct.quarters[quarterIdx].value;
                    product.quarters[quarterIdx].value = qUnit !== 0 ? TwoDecimalPlace(qValue / qUnit) : 0;

                  });

              });

          });

        this.state.dataSource.rows[rowIdx].products[productIdx].value =
          TwoDecimalPlace(
            this.state.dataSource.rows[planValueIdx].products[productIdx].value /
            this.state.dataSource.rows[planUnitIdx].products[productIdx].value
          );

        this.state.dataSource.rows[rowIdx].products[avgIdx].value =
          TwoDecimalPlace(
            this.state.dataSource.rows[planValueIdx].products[totalIdx].value /
            this.state.dataSource.rows[planUnitIdx].products[totalIdx].value
          );

        //Calculate Margin $ Quarter's Total
        this.state.dataSource.rows[planMarginIdx].products[totalIdx].quarters[quarterIdx].value =
          calculateQuarterTotal(this.state.dataSource.rows[planMarginIdx].products, quarterIdx, 'Margin $');

        //Calculate Margin $ Product's Total
        this.state.dataSource.rows[planMarginIdx].products.forEach((product, pIdx) => {
          product.value = calculateProductTotal(rowArr, planMarginIdx, pIdx, 'Margin $');
        });


      }
    }

    if (measureGroup === 'Margin %' && productName !== 'Average') {
      const marginValueIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Margin $');
      const planValueIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - $');
      const planQuotaValue = this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].value;

      this.state.dataSource.rows[rowIdx].products[productIdx].quarters[quarterIdx].isChanged = false;
      this.state.dataSource.rows[marginValueIdx].products[productIdx].quarters[quarterIdx].isChanged = true;
      this.state.dataSource.rows[marginValueIdx].products[productIdx].quarters[quarterIdx].value =
        TwoDecimalPlace((planQuotaValue * value) / 100);

      this.state.dataSource.rows[marginValueIdx].products[productIdx].value =
        calculateEachProductTotal(
          this.state.dataSource.rows[marginValueIdx].products[productIdx].quarters,
          'Margin $'
        );

      const totalIdx = this.state.dataSource.rows[marginValueIdx].products.findIndex((product) => product.name === 'Total');
      const avgIdx = this.state.dataSource.rows[rowIdx].products.findIndex((product) => product.name === 'Average');
      this.state.dataSource.rows[marginValueIdx].products[totalIdx].quarters[quarterIdx].value =
        calculateQuarterTotal(this.state.dataSource.rows[marginValueIdx].products, quarterIdx, measureGroup);
      this.state.dataSource.rows[marginValueIdx].products[totalIdx].value =
        calculateMeasureTotal(this.state.dataSource.rows[marginValueIdx].products, measureGroup);

      this.state.dataSource.rows[rowIdx].products[productIdx].value =
        TwoDecimalPlace(
          (this.state.dataSource.rows[marginValueIdx].products[productIdx].value /
            this.state.dataSource.rows[planValueIdx].products[productIdx].value) * 100
        );
      this.state.dataSource.rows[rowIdx].products[avgIdx].value =
        TwoDecimalPlace(
          (this.state.dataSource.rows[marginValueIdx].products[totalIdx].value /
            this.state.dataSource.rows[planValueIdx].products[totalIdx].value) * 100
        );
      this.state.dataSource.rows[rowIdx].products[avgIdx].quarters[quarterIdx].value =
        TwoDecimalPlace(
          (this.state.dataSource.rows[marginValueIdx].products[totalIdx].quarters[quarterIdx].value /
            this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].value) * 100
        );

        this.state.dataSource.rows[marginValueIdx].products[productIdx].isDisabled = true;
        this.state.dataSource.rows[marginValueIdx].products[productIdx].quarters[quarterIdx].isDisabled = true;
    }

    if (measureGroup === 'Margin %' && productName === 'Average') {
      const marginValueIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Margin $');
      const planValueIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - $');
      const planQuotaValue = this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].value;

      this.state.dataSource.rows[rowIdx].products[productIdx].quarters[quarterIdx].isChanged = false;

      const totalIdx = this.state.dataSource.rows[marginValueIdx].products.findIndex((product) => product.name === 'Total');
      this.state.dataSource.rows[marginValueIdx].products[totalIdx].quarters[quarterIdx].value =
        TwoDecimalPlace((planQuotaValue * value) / 100);

      this.state.dataSource.rows[marginValueIdx].products
        .filter((product) => product.name !== 'Total')
        .forEach((product) => {
          product.quarters[quarterIdx].value =
            Math.round(
              (product.quarters[quarterIdx].oldVal /
                this.state.dataSource.rows[marginValueIdx].products[totalIdx].quarters[quarterIdx].oldVal)
              * this.state.dataSource.rows[marginValueIdx].products[totalIdx].quarters[quarterIdx].value
            );
          product.quarters[quarterIdx].isChanged = true;
        });

      this.state.dataSource.rows[rowIdx].products.forEach((product) => {
        product.value = calculateEachProductTotal(product.quarters, measureGroup);
      });

      this.state.dataSource.rows[rowIdx].products
        .filter((product, idx) => this.state.dataSource.rows[rowIdx].products.length - 1 !== idx)
        .forEach((product, pIdx: number) => {
          product.quarters[quarterIdx].value =
            calculateQuarterValue(rowArr, rowIdx, pIdx, quarterIdx, measureGroup);
        });
      this.state.dataSource.rows[rowIdx].products.forEach((product, pIdx: number) => {
        product.value = calculateProductTotal(rowArr, rowIdx, pIdx, measureGroup);
      });
    }

    if (measureGroup === 'Margin $' && productName !== 'Total') {
      const totalIdx = this.state.dataSource.rows[rowIdx].products.findIndex((product) => product.name === 'Total');     
      const marginPctIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Margin %');
      const planValueIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - $');
      const planUnitIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - UNITS');
      
      const planQuotaValue = this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].value;
      this.state.dataSource.rows[marginPctIdx].products[productIdx].quarters[quarterIdx].value =
      TwoDecimalPlace((value/planQuotaValue)*100);

      this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].isChanged = true;
      //this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].isChanged = true;
      //this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;

      this.state.dataSource.rows[rowIdx].products[totalIdx].quarters[quarterIdx].value =
        calculateQuarterTotal(this.state.dataSource.rows[rowIdx].products, quarterIdx, measureGroup);
      this.state.dataSource.rows[rowIdx].products[totalIdx].value =
        calculateMeasureTotal(this.state.dataSource.rows[rowIdx].products, measureGroup);
      this.state.dataSource.rows[rowIdx].products.forEach((product) => {
        product.value = calculateEachProductTotal(product.quarters, measureGroup);
      });

      this.state.dataSource.rows[marginPctIdx].products[productIdx].isDisabled = true;
      this.state.dataSource.rows[marginPctIdx].products[productIdx].quarters[quarterIdx].isDisabled = true;
    }

    if (measureGroup === 'Margin $' && productName === 'Total') {
      const totalIdx = this.state.dataSource.rows[rowIdx].products.findIndex((product) => product.name === 'Total');
      const marginPctIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Margin %');
      const planValueIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - $');
      const planUnitIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - UNITS');
      const planMarginIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Margin $');

      this.state.dataSource.rows[rowIdx].products
        .filter((product) => product.name !== 'Total')
        .forEach((product) => {
          product.quarters[quarterIdx].value =
            Math.round(
              (product.quarters[quarterIdx].oldVal /
                this.state.dataSource.rows[rowIdx].products[totalIdx].quarters[quarterIdx].oldVal)
              * value
            );
          product.quarters[quarterIdx].isChanged = true;
        });
      this.state.dataSource.rows[rowIdx].products.forEach((product) => {
        product.value = calculateEachProductTotal(product.quarters, measureGroup);
      });
//Start
      this.state.dataSource.rows[marginPctIdx].products
          .filter((product) => (product.name !== 'Total'))
          .forEach((product, pIdx: number) => {
           const pp =  this.state.dataSource.rows[planValueIdx];
            const planQuotaValue = this.state.dataSource.rows[planValueIdx].products[pIdx].quarters[quarterIdx].value;
            const planMargin = this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].value;
            this.state.dataSource.rows[marginPctIdx].products[pIdx].quarters[quarterIdx].value =
            TwoDecimalPlace((planMargin/planQuotaValue)*100);          
          
            this.state.dataSource.rows[planUnitIdx].products[pIdx].quarters[quarterIdx].isChanged = true;
            this.state.dataSource.rows[planValueIdx].products[pIdx].quarters[quarterIdx].isChanged = true;
            this.state.dataSource.rows[marginPctIdx].products[pIdx].quarters[quarterIdx].isDisabled = true;
          });

//End
      this.state.dataSource.rows[marginPctIdx].products
        .filter((product, pIdx: number) => this.state.dataSource.rows[marginPctIdx].products.length - 1 !== pIdx)
        .forEach((product) => {
          product.isDisabled = true;
          product.quarters.forEach((quarter) => {
            quarter.isDisabled = true;
          });
        });


    }

    this.props.UpdateEditRestriction(true);
    this.setState({ dataSource: this.state.dataSource });
  }

  updateWeekCalculation(
    rowArr,
    rowIdx: number,
    productIdx: number,
    quarterIdx: number,
    weekIdx: number,
    measureGroup: string,
    productName: string,
    event
  ): void {
    const value: any = event.target.value !== '' ? parseFloat(event.target.value) : '';

    this.state.dataSource.rows[rowIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value = value;
    this.state.dataSource.rows[rowIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isEdited = true;
    this.state.dataSource.rows[rowIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
    this.state.dataSource.rows[rowIdx].products[productIdx].quarters[quarterIdx].isChanged = true;

    if (measureGroup === 'Plan / Quota - UNITS' && productName !== 'Total') {
      const totalIdx = this.state.dataSource.rows[rowIdx].products.findIndex((product) => product.name === 'Total');

      /*Update week, quarter and measure value of Plan / Quota - UNITS*/
      this.state.dataSource.rows[rowIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value =
        calculateVerticalWeekTotal(this.state.dataSource.rows[rowIdx].products, quarterIdx, weekIdx, measureGroup);
      this.state.dataSource.rows[rowIdx].products[productIdx].quarters[quarterIdx].value =
        calculateHorizontalWeekTotal(this.state.dataSource.rows[rowIdx].products[productIdx].quarters[quarterIdx].weeks, measureGroup);
      this.state.dataSource.rows[rowIdx].products[totalIdx].quarters[quarterIdx].value =
        calculateHorizontalWeekTotal(this.state.dataSource.rows[rowIdx].products[totalIdx].quarters[quarterIdx].weeks, measureGroup);

      this.state.dataSource.rows[rowIdx].products[totalIdx].value =
        calculateMeasureTotal(this.state.dataSource.rows[rowIdx].products, measureGroup);
      this.state.dataSource.rows[rowIdx].products.forEach((product) => {
        product.value = calculateEachProductTotal(product.quarters, measureGroup);
      });

      /*Update week, quarter and measure value of Plan ASP*/
      const planValueIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - $');
      const planAspIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan ASP');
      const planMarginIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Margin $');

      const avgIdx = this.state.dataSource.rows[planAspIdx].products.findIndex((product) => product.name === 'Average');
      const planValueTotalIdx = this.state.dataSource.rows[planValueIdx].products.findIndex((product) => product.name === 'Total');
      const marginTotalIdx = this.state.dataSource.rows[planMarginIdx].products.findIndex((product) => product.name === 'Total');
      const planQuotaValue = this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value;

      /*edit control for dependent measures*/
      this.state.dataSource.rows[rowIdx].products[totalIdx].quarters[quarterIdx].weeks.forEach((week) => {
        week.isDisabled = true;
      });
      this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].weeks.forEach((week) => {
        week.isDisabled = true;
      });
      this.state.dataSource.rows[planAspIdx].products[totalIdx].quarters[quarterIdx].weeks.forEach((week) => {
        week.isDisabled = true;
      });

      const isPlanAspEdited = this.state.dataSource.rows[planAspIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isEdited;
      const isPlanValueEdited = this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isEdited;

      if (isPlanAspEdited) {
        /*Calculation of Plan Quota when UNIT and ASP are edited*/
        const planAspValue = this.state.dataSource.rows[planAspIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value;
        this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value =
          TwoDecimalPlace(value * planAspValue);

        /*Calculation of Plan Quota total when UNIT and ASP are edited*/
        const planValueTotal = this.state.dataSource.rows[rowIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value;
        const planAspTotal = this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters[quarterIdx].weeks[weekIdx].value;

        this.state.dataSource.rows[rowIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value =
          planAspTotal !== 0 ? Math.round(planValueTotal / planAspTotal) : 0;

        this.state.dataSource.rows[rowIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value =
          calculateWeekTotalForEachMeasure(rowArr, planAspIdx, productIdx, quarterIdx, weekIdx, 'Plan ASP');
        this.state.dataSource.rows[rowIdx].products[totalIdx].quarters[quarterIdx].value =
          calculateQuarterValue(rowArr, planAspIdx, productIdx, quarterIdx, 'Plan ASP');
        this.state.dataSource.rows[rowIdx].products[totalIdx].value =
          calculateProductTotal(rowArr, planAspIdx, productIdx, 'Plan ASP');

        this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;
      } else if (isPlanValueEdited) {
        this.state.dataSource.rows[planAspIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value =
          TwoDecimalPlace(planQuotaValue / value);
        this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters[quarterIdx].weeks[weekIdx].value =
          calculateWeekTotalForEachMeasure(rowArr, planAspIdx, productIdx, quarterIdx, weekIdx, 'Plan ASP');
        this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters[quarterIdx].value =
          calculateQuarterValue(rowArr, planAspIdx, productIdx, quarterIdx, 'Plan ASP');
        this.state.dataSource.rows[planAspIdx].products[avgIdx].value =
          calculateProductTotal(rowArr, planAspIdx, productIdx, 'Plan ASP');

        this.state.dataSource.rows[planAspIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;
      } else {

        //Calculate Margin % from old Sales and Margin $ value
        const oldPlanValue = this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value;
        const oldMarginValue = this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value;
        const planMarginPctValue = (oldMarginValue / oldPlanValue) * 100;

        const planUnitValue = this.state.dataSource.rows[rowIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value;
        const planAspValue = this.state.dataSource.rows[planAspIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value;
        this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value =
          TwoDecimalPlace(planUnitValue * planAspValue);
        //this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;

        this.state.dataSource.rows[planValueIdx].products[planValueTotalIdx].quarters[quarterIdx].weeks[weekIdx].value =
          calculateVerticalWeekTotal(this.state.dataSource.rows[planValueIdx].products, quarterIdx, weekIdx, 'Plan / Quota - $');

        this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].value =
          calculateHorizontalWeekTotal(this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks, 'Plan / Quota - $');
        this.state.dataSource.rows[planValueIdx].products[planValueTotalIdx].quarters[quarterIdx].value =
          calculateHorizontalWeekTotal(this.state.dataSource.rows[planValueIdx].products[planValueTotalIdx].quarters[quarterIdx].weeks, 'Plan / Quota - $');

        this.state.dataSource.rows[planValueIdx].products.forEach((product) => {
          product.value = calculateEachProductTotal(product.quarters, 'Plan / Quota - $');
        });
        this.state.dataSource.rows[planValueIdx].products[planValueTotalIdx].value =
          calculateProductTotal(rowArr, planValueIdx, planValueTotalIdx, 'Plan / Quota - $');
        this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].isChanged = true;
        this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;

        //Caluclate Margin $ Value
        const newSalesPlanValue = this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value;
        this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value =
          TwoDecimalPlace(newSalesPlanValue * (planMarginPctValue / 100));
        this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;

        this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].isChanged = true;
        this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;

        this.state.dataSource.rows[planMarginIdx].products[planValueTotalIdx].quarters[quarterIdx].weeks[weekIdx].value =
          calculateVerticalWeekTotal(this.state.dataSource.rows[planMarginIdx].products, quarterIdx, weekIdx, 'Margin $');
        this.state.dataSource.rows[planMarginIdx].products[planValueTotalIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;

        this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].value =
          calculateHorizontalWeekTotal(this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].weeks, 'Margin $');
        this.state.dataSource.rows[planMarginIdx].products[planValueTotalIdx].quarters[quarterIdx].value =
          calculateHorizontalWeekTotal(this.state.dataSource.rows[planMarginIdx].products[planValueTotalIdx].quarters[quarterIdx].weeks, 'Margin $');

        this.state.dataSource.rows[planMarginIdx].products.forEach((product) => {
          product.value = calculateEachProductTotal(product.quarters, 'Margin $');
        });

      }
    }

    if (measureGroup === 'Plan / Quota - UNITS' && productName === 'Total') {
      /*Update week, quarter and measure value of Plan / Quota - UNITS*/
      const measureIdx = this.state.dataSource.rows.findIndex((row) => row.name === measureGroup);
      const totalIdx = this.state.dataSource.rows[rowIdx].products.findIndex((product) => product.name === 'Total');

      this.state.dataSource.rows[measureIdx].products
        .filter((product) => product.name !== 'Total')
        .forEach((product) => {
          product.quarters[quarterIdx].weeks[weekIdx].value =
            Math.round(
              (product.quarters[quarterIdx].weeks[weekIdx].oldVal /
                this.state.dataSource.rows[measureIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].oldVal)
              * value
            );
          product.quarters[quarterIdx].weeks[weekIdx].isChanged = true;
          product.quarters[quarterIdx].isChanged = true;
        });
      this.state.dataSource.rows[rowIdx].products.forEach((product) => {
        product.quarters.forEach((quarter) => {
          quarter.value = calculateHorizontalWeekTotal(quarter.weeks, measureGroup);
        });
      });
      this.state.dataSource.rows[rowIdx].products.forEach((product) => {
        product.value = calculateEachProductTotal(product.quarters, measureGroup);
      });

      const planAspIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan ASP');
      const avgIdx = this.state.dataSource.rows[planAspIdx].products.findIndex((product) => product.name === 'Average');

      /*edit control for dependent measures*/
      const planMarginIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Margin $');
      const marginTotalIdx = this.state.dataSource.rows[planMarginIdx].products.findIndex((product) => product.name === 'Total');
      const planValueIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - $');

      this.state.dataSource.rows[rowIdx].products
        .filter((product, pIdx: number) => this.state.dataSource.rows[rowIdx].products.length - 1 !== pIdx)
        .forEach((product) => {
          product.quarters[quarterIdx].weeks.forEach((week) => {
            week.isDisabled = true;
          });
        });
      this.state.dataSource.rows[planValueIdx].products
        .filter((product, pIdx: number) => this.state.dataSource.rows[planValueIdx].products.length - 1 !== pIdx)
        .forEach((product) => {
          product.quarters[quarterIdx].weeks.forEach((week) => {
            week.isDisabled = true;
          });
        });
      this.state.dataSource.rows[planAspIdx].products
        .filter((product, pIdx: number) => this.state.dataSource.rows[planAspIdx].products.length - 1 !== pIdx)
        .forEach((product) => {
          product.quarters[quarterIdx].weeks.forEach((week) => {
            week.isDisabled = true;
          });
        });

      this.state.dataSource.rows[planMarginIdx].products
        .filter((product, pIdx: number) => this.state.dataSource.rows[planMarginIdx].products.length - 1 !== pIdx)
        .forEach((product) => {
          product.quarters[quarterIdx].weeks.forEach((week) => {
            week.isDisabled = true;
          });
        });

      const isPlanAspEdited = this.state.dataSource.rows[planAspIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].isEdited;
      const isPlanValueEdited = this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].isEdited;

      if (isPlanAspEdited) {
        const planAspWeekTotal = this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters[quarterIdx].weeks[weekIdx].value;
        this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value =
          TwoDecimalPlace(value * planAspWeekTotal);

        this.state.dataSource.rows[planValueIdx].products
          .filter((product) => product.name !== 'Total')
          .forEach((product) => {
            product.quarters[quarterIdx].weeks[weekIdx].value =
              TwoDecimalPlace(
                (product.quarters[quarterIdx].weeks[weekIdx].oldVal /
                  this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].oldVal)
                * TwoDecimalPlace(value * planAspWeekTotal)
              );
            product.quarters[quarterIdx].weeks[weekIdx].isChanged = true;
            product.quarters[quarterIdx].isChanged = true;
          });
        this.state.dataSource.rows[rowIdx].products.forEach((product) => {
          product.quarters.forEach((quarter) => {
            quarter.value = calculateHorizontalWeekTotal(quarter.weeks, measureGroup);
          });
        });
        this.state.dataSource.rows[rowIdx].products.forEach((product) => {
          product.value = calculateEachProductTotal(product.quarters, measureGroup);
        });

        this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;
      } else if (isPlanValueEdited) {
        const planValueWeekTotal = this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value;
        this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters[quarterIdx].weeks[weekIdx].value =
          value !== 0 ? TwoDecimalPlace(planValueWeekTotal / value) : 0;

        this.state.dataSource.rows[planAspIdx].products
          .filter((product) => product.name !== 'Average')
          .forEach((product) => {
            product.quarters[quarterIdx].weeks[weekIdx].value =
              TwoDecimalPlace(
                (product.quarters[quarterIdx].weeks[weekIdx].oldVal /
                  this.state.dataSource.rows[planAspIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].oldVal)
                * value
              );
            product.quarters[quarterIdx].weeks[weekIdx].isChanged = true;
          });
        this.state.dataSource.rows[planAspIdx].products.forEach((product, pIdx: number) => {
          product.quarters.forEach((quarter, qIdx: number) => {
            quarter.value = calculateQuarterValue(rowArr, planAspIdx, pIdx, qIdx, 'Plan ASP');
          });
        });
        this.state.dataSource.rows[planAspIdx].products.forEach((product, pIdx: number) => {
          product.value = calculateProductTotal(rowArr, planAspIdx, pIdx, 'Plan ASP');
        });

        this.state.dataSource.rows[planAspIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;
      } else {
        const planValueTotalIdx = this.state.dataSource.rows[planValueIdx].products.findIndex((product) => product.name === 'Total');
        this.state.dataSource.rows[planValueIdx].products[planValueTotalIdx].quarters[quarterIdx].weeks[weekIdx].value =
          TwoDecimalPlace(value * this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters[quarterIdx].weeks[weekIdx].value);
        this.state.dataSource.rows[planValueIdx].products
          .filter((product) => (product.name !== 'Total'))
          .forEach((product, pIdx: number) => {

            //Calulate Margin % for Each Product from old Margin $ and old Sales Value
            const oldMarginValue = this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].weeks[weekIdx].oldVal;
            const oldSalesValue = product.quarters[quarterIdx].weeks[weekIdx].oldVal;
            const oldMarginPctValue = (oldMarginValue / oldSalesValue) * 100;

            const unitValue = this.state.dataSource.rows[rowIdx].products[pIdx].quarters[quarterIdx].weeks[weekIdx].value;
            const aspValue = this.state.dataSource.rows[planAspIdx].products[pIdx].quarters[quarterIdx].weeks[weekIdx].value;
            product.quarters[quarterIdx].weeks[weekIdx].value =
              TwoDecimalPlace((product.quarters[quarterIdx].weeks[weekIdx].oldVal / this.state.dataSource.rows[planValueIdx].products[planValueTotalIdx].quarters[quarterIdx].weeks[weekIdx].oldVal) * this.state.dataSource.rows[planValueIdx].products[planValueTotalIdx].quarters[quarterIdx].weeks[weekIdx].value);
            //TwoDecimalPlace(unitValue * aspValue);
            product.quarters[quarterIdx].weeks[weekIdx].isChanged = true;
            product.quarters[quarterIdx].isChanged = true;

            //Calculate Margin $
            const newSalesValue = product.quarters[quarterIdx].weeks[weekIdx].value;
            this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].weeks[weekIdx].value = TwoDecimalPlace(newSalesValue * (oldMarginPctValue / 100));
            this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
            this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].isChanged = true;

          });

        //this.state.dataSource.rows[planValueIdx].products[planValueTotalIdx].quarters[quarterIdx].weeks[weekIdx].value =
        //calculateVerticalWeekTotal(this.state.dataSource.rows[planValueIdx].products, quarterIdx, weekIdx, 'Plan / Quota - $');

        this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].value =
          calculateHorizontalWeekTotal(this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks, 'Plan / Quota - $');

        this.state.dataSource.rows[planValueIdx].products.forEach((product) => {
          product.quarters
            .filter((quarter) => !quarter.isPast)
            .forEach((quarter) => {
              quarter.value = calculateHorizontalWeekTotal(quarter.weeks, measureGroup);
            });
        });

        this.state.dataSource.rows[planValueIdx].products.forEach((product, pIdx: number) => {
          product.value = calculateProductTotal(rowArr, planValueIdx, pIdx, 'Plan / Quota - $');
        });

        this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;

        // Calculate Margin $ value
        this.state.dataSource.rows[planMarginIdx].products[planValueTotalIdx].quarters[quarterIdx].weeks[weekIdx].value =
          calculateVerticalWeekTotal(this.state.dataSource.rows[planMarginIdx].products, quarterIdx, weekIdx, 'Margin $');

        this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].value =
          calculateHorizontalWeekTotal(this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].weeks, 'Margin $');

        this.state.dataSource.rows[planMarginIdx].products.forEach((product) => {
          product.quarters
            .filter((quarter) => !quarter.isPast)
            .forEach((quarter) => {
              quarter.value = calculateHorizontalWeekTotal(quarter.weeks, 'Margin $');
            });
        });

        this.state.dataSource.rows[planMarginIdx].products.forEach((product, pIdx: number) => {
          product.value = calculateProductTotal(rowArr, planMarginIdx, pIdx, 'Margin $');
        });

      }
    }

    if (measureGroup === 'Plan / Quota - $' && productName !== 'Total') {
      const totalIdx = this.state.dataSource.rows[rowIdx].products.findIndex((product) => product.name === 'Total');

      /*Update week, quarter and measure value of Plan / Quota - UNITS*/
      this.state.dataSource.rows[rowIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value =
        calculateVerticalWeekTotal(this.state.dataSource.rows[rowIdx].products, quarterIdx, weekIdx, measureGroup);
      this.state.dataSource.rows[rowIdx].products[productIdx].quarters[quarterIdx].value =
        calculateHorizontalWeekTotal(this.state.dataSource.rows[rowIdx].products[productIdx].quarters[quarterIdx].weeks, measureGroup);
      this.state.dataSource.rows[rowIdx].products[totalIdx].quarters[quarterIdx].value =
        calculateHorizontalWeekTotal(this.state.dataSource.rows[rowIdx].products[totalIdx].quarters[quarterIdx].weeks, measureGroup);

      this.state.dataSource.rows[rowIdx].products[totalIdx].value =
        calculateMeasureTotal(this.state.dataSource.rows[rowIdx].products, measureGroup);
      this.state.dataSource.rows[rowIdx].products.forEach((product) => {
        product.value = calculateEachProductTotal(product.quarters, measureGroup);
      });

      const planUnitIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - UNITS');
      const planAspIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan ASP');
      const planMarginIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Margin $');

      const avgIdx = this.state.dataSource.rows[planAspIdx].products.findIndex((product) => product.name === 'Average');
      const marginTotalIdx = this.state.dataSource.rows[planMarginIdx].products.findIndex((product) => product.name === 'Total');

      //Calculate old Margin pct
      const oldPlanMarginValue = this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].oldVal;
      const oldSalesValue = this.state.dataSource.rows[rowIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].oldVal;
      const oldMarginPctValue = (oldPlanMarginValue / oldSalesValue) * 100;

      /*edit control for dependent measures*/
      this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].weeks.forEach((week) => {
        week.isDisabled = true;
      });
      this.state.dataSource.rows[rowIdx].products[totalIdx].quarters[quarterIdx].weeks.forEach((week) => {
        week.isDisabled = true;
      });
      this.state.dataSource.rows[planAspIdx].products[totalIdx].quarters[quarterIdx].weeks.forEach((week) => {
        week.isDisabled = true;
      });
      this.state.dataSource.rows[planMarginIdx].products[marginTotalIdx].quarters[quarterIdx].weeks.forEach((week) => {
        week.isDisabled = true;
      });

      const isPlanAspEdited = this.state.dataSource.rows[planAspIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isEdited;
      const isPlanUnitEdited = this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isEdited;

      if (isPlanAspEdited) {
        /*Calculation of UNIT when Plan Quota and ASP are edited*/
        const planAspValue = this.state.dataSource.rows[planAspIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value;
        this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value =
          planAspValue !== 0 ? Math.round(value / planAspValue) : 0;

        /*Calculation of UNIT total when Plan Quota and ASP are edited*/
        const planValueTotal = this.state.dataSource.rows[rowIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value;
        const planAspTotal = this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters[quarterIdx].weeks[weekIdx].value;

        this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value =
          planAspTotal !== 0 ? Math.round(planValueTotal / planAspTotal) : 0;
        this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value =
          calculateVerticalWeekTotal(this.state.dataSource.rows[planUnitIdx].products, quarterIdx, weekIdx, 'Plan / Quota - UNITS');
        this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].value =
          calculateHorizontalWeekTotal(this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].weeks, 'Plan / Quota - UNITS');
        this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].value =
          calculateHorizontalWeekTotal(this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].weeks, 'Plan / Quota - UNITS');

        this.state.dataSource.rows[planUnitIdx].products[totalIdx].value =
          calculateMeasureTotal(this.state.dataSource.rows[planUnitIdx].products, 'Plan / Quota - UNITS');
        this.state.dataSource.rows[planUnitIdx].products.forEach((product) => {
          product.value = calculateEachProductTotal(product.quarters, 'Plan / Quota - UNITS');
        });

        this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;
      } else if (isPlanUnitEdited) {
        /*Calculation of ASP when Plan Quota and UNIT are edited*/
        const planUnitValue = this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value;
        this.state.dataSource.rows[planAspIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value =
          planUnitValue !== 0 ? TwoDecimalPlace(value / planUnitValue) : 0;

        /*Calculation of ASP total when Plan Quota and UNIT are edited*/
        this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters[quarterIdx].weeks[weekIdx].value =
          calculateWeekTotalForEachMeasure(rowArr, planAspIdx, productIdx, quarterIdx, weekIdx, 'Plan ASP');
        this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters[quarterIdx].value =
          calculateQuarterValue(rowArr, planAspIdx, productIdx, quarterIdx, 'Plan ASP');
        this.state.dataSource.rows[planAspIdx].products[avgIdx].value =
          calculateProductTotal(rowArr, planAspIdx, productIdx, 'Plan ASP');

        this.state.dataSource.rows[planAspIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;
      } else {
        this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].isChanged = true;
        this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
        // this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;
        /*Calculation of UNIT when Plan Quota and ASP are edited*/
        const planAspValue = this.state.dataSource.rows[planAspIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value;
        this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value =
          planAspValue !== 0 ? Math.round(value / planAspValue) : 0;

        /*Calculation of UNIT total when Plan Quota and ASP are edited*/
        const planValueTotal = this.state.dataSource.rows[rowIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value;
        const planAspTotal = this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters[quarterIdx].weeks[weekIdx].value;

        this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value =
          planAspTotal !== 0 ? Math.round(planValueTotal / planAspTotal) : 0;
        this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value =
          calculateVerticalWeekTotal(this.state.dataSource.rows[planUnitIdx].products, quarterIdx, weekIdx, 'Plan / Quota - UNITS');
        this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].value =
          calculateHorizontalWeekTotal(this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].weeks, 'Plan / Quota - UNITS');
        this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].value =
          calculateHorizontalWeekTotal(this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].weeks, 'Plan / Quota - UNITS');

        this.state.dataSource.rows[planUnitIdx].products[totalIdx].value =
          calculateMeasureTotal(this.state.dataSource.rows[planUnitIdx].products, 'Plan / Quota - UNITS');
        this.state.dataSource.rows[planUnitIdx].products.forEach((product) => {
          product.value = calculateEachProductTotal(product.quarters, 'Plan / Quota - UNITS');
        });

        //Caluclate Margin $ Value
        const newSalesPlanValue = this.state.dataSource.rows[rowIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value;
        this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value =
          TwoDecimalPlace(newSalesPlanValue * (oldMarginPctValue / 100));

        this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].isChanged = true;
        this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
        this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;

        this.state.dataSource.rows[planMarginIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value =
          calculateVerticalWeekTotal(this.state.dataSource.rows[planMarginIdx].products, quarterIdx, weekIdx, 'Margin $');
        this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].value =
          calculateHorizontalWeekTotal(this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].weeks, 'Margin $');
        this.state.dataSource.rows[planMarginIdx].products[totalIdx].quarters[quarterIdx].value =
          calculateHorizontalWeekTotal(this.state.dataSource.rows[planMarginIdx].products[totalIdx].quarters[quarterIdx].weeks, 'Margin $');

        this.state.dataSource.rows[planMarginIdx].products.forEach((product) => {
          product.value = calculateEachProductTotal(product.quarters, 'Margin $');
        });

      }
    }

    if (measureGroup === 'Plan / Quota - $' && productName === 'Total') {
      /*Update week, quarter and measure value of Plan / Quota - UNITS*/
      const measureIdx = this.state.dataSource.rows.findIndex((row) => row.name === measureGroup);
      const planMarginIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Margin $');

      const totalIdx = this.state.dataSource.rows[rowIdx].products.findIndex((product) => product.name === 'Total');
      const marginTotalIdx = this.state.dataSource.rows[planMarginIdx].products.findIndex((product) => product.name === 'Total');

      this.state.dataSource.rows[measureIdx].products
        .filter((product) => product.name !== 'Total')
        .forEach((product, pIdx) => {

          //Calulate Margin % for Each Product from old Margin $ and old Sales Value
          const oldMarginValue = this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].weeks[weekIdx].oldVal;
          const oldSalesValue = product.quarters[quarterIdx].weeks[weekIdx].oldVal;
          const oldMarginPctValue = (oldMarginValue / oldSalesValue) * 100;

          product.quarters[quarterIdx].weeks[weekIdx].value =
            TwoDecimalPlace(
              (product.quarters[quarterIdx].weeks[weekIdx].oldVal /
                this.state.dataSource.rows[measureIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].oldVal)
              * value
            );
          product.quarters[quarterIdx].weeks[weekIdx].isChanged = true;
          product.quarters[quarterIdx].isChanged = true;

          //Calculate Margin $
          const newSalesValue = product.quarters[quarterIdx].weeks[weekIdx].value;
          this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].weeks[weekIdx].value = TwoDecimalPlace(newSalesValue * (oldMarginPctValue / 100));
          this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
          this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].isChanged = true;
          this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;

        });

      this.state.dataSource.rows[planMarginIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value =
        calculateVerticalWeekTotal(this.state.dataSource.rows[planMarginIdx].products, quarterIdx, weekIdx, 'Margin $');

      this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].value =
        calculateHorizontalWeekTotal(this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].weeks, 'Margin $');

      this.state.dataSource.rows[planMarginIdx].products.forEach((product) => {
        product.quarters
          .filter((quarter) => !quarter.isPast)
          .forEach((quarter) => {
            quarter.value = calculateHorizontalWeekTotal(quarter.weeks, 'Margin $');
          });
      });

      this.state.dataSource.rows[planMarginIdx].products.forEach((product, pIdx: number) => {
        product.value = calculateProductTotal(rowArr, planMarginIdx, pIdx, 'Margin $');
      });

      this.state.dataSource.rows[rowIdx].products.forEach((product) => {
        product.quarters.forEach((quarter) => {
          quarter.value = calculateHorizontalWeekTotal(quarter.weeks, measureGroup);
        });
      });
      this.state.dataSource.rows[rowIdx].products.forEach((product) => {
        product.value = calculateEachProductTotal(product.quarters, measureGroup);
      });

      const planUnitIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - UNITS');
      const planAspIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan ASP');
      const avgIdx = this.state.dataSource.rows[planAspIdx].products.findIndex((product) => product.name === 'Average');

      /*edit control for dependent measures*/
      this.state.dataSource.rows[planUnitIdx].products
        .filter((product, pIdx: number) => this.state.dataSource.rows[planUnitIdx].products.length - 1 !== pIdx)
        .forEach((product) => {
          product.quarters[quarterIdx].weeks.forEach((week) => {
            week.isDisabled = true;
          });
        });
      this.state.dataSource.rows[rowIdx].products
        .filter((product, pIdx: number) => this.state.dataSource.rows[rowIdx].products.length - 1 !== pIdx)
        .forEach((product) => {
          product.quarters[quarterIdx].weeks.forEach((week) => {
            week.isDisabled = true;
          });
        });
      this.state.dataSource.rows[planAspIdx].products
        .filter((product, pIdx: number) => this.state.dataSource.rows[planAspIdx].products.length - 1 !== pIdx)
        .forEach((product) => {
          product.quarters[quarterIdx].weeks.forEach((week) => {
            week.isDisabled = true;
          });
        });

      const isPlanAspEdited = this.state.dataSource.rows[planAspIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].isEdited;
      const isPlanUnitEdited = this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].isEdited;

      if (isPlanAspEdited) {
        const planAspWeekTotal = this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters[quarterIdx].weeks[weekIdx].value;
        this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value =
          planAspWeekTotal !== 0 ? Math.round(value / planAspWeekTotal) : 0;

        this.state.dataSource.rows[planUnitIdx].products
          .filter((product) => product.name !== 'Total')
          .forEach((product) => {
            product.quarters[quarterIdx].weeks[weekIdx].value =
              Math.round(
                (product.quarters[quarterIdx].weeks[weekIdx].oldVal /
                  this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].oldVal)
                * value
              );
            product.quarters[quarterIdx].weeks[weekIdx].isChanged = true;
            product.quarters[quarterIdx].isChanged = true;
          });
        this.state.dataSource.rows[planUnitIdx].products.forEach((product) => {
          product.quarters.forEach((quarter) => {
            quarter.value = calculateHorizontalWeekTotal(quarter.weeks, measureGroup);
          });
        });
        this.state.dataSource.rows[planUnitIdx].products.forEach((product) => {
          product.value = calculateEachProductTotal(product.quarters, measureGroup);
        });

        this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;
      } else if (isPlanUnitEdited) {
        const planUnitValue = this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value;
        this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters[quarterIdx].weeks[weekIdx].value =
          planUnitValue !== 0 ? TwoDecimalPlace(value / planUnitValue) : 0;

        this.state.dataSource.rows[planAspIdx].products
          .filter((product) => product.name !== 'Average')
          .forEach((product) => {
            product.quarters[quarterIdx].weeks[weekIdx].value =
              TwoDecimalPlace(
                (product.quarters[quarterIdx].weeks[weekIdx].oldVal /
                  this.state.dataSource.rows[planAspIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].oldVal)
                * value
              );
            product.quarters[quarterIdx].weeks[weekIdx].isChanged = true;
          });
        this.state.dataSource.rows[planAspIdx].products.forEach((product, pIdx: number) => {
          product.quarters.forEach((quarter, qIdx: number) => {
            quarter.value = calculateQuarterValue(rowArr, planAspIdx, pIdx, qIdx, 'Plan ASP');
          });
        });
        this.state.dataSource.rows[planAspIdx].products.forEach((product, pIdx: number) => {
          product.value = calculateProductTotal(rowArr, planAspIdx, pIdx, 'Plan ASP');
        });

        this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;
      } else {
        const planAspWeekTotal = this.state.dataSource.rows[planAspIdx].products[avgIdx].quarters[quarterIdx].weeks[weekIdx].value;
        this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value =
          planAspWeekTotal !== 0 ? Math.round(value / planAspWeekTotal) : 0;

        this.state.dataSource.rows[planUnitIdx].products
          .filter((product) => product.name !== 'Total')
          .forEach((product, pIdx) => {
            const salesValue = this.state.dataSource.rows[rowIdx].products[pIdx].quarters[quarterIdx].weeks[weekIdx].value;
            const aspValue = this.state.dataSource.rows[planAspIdx].products[pIdx].quarters[quarterIdx].weeks[weekIdx].value;
            product.quarters[quarterIdx].weeks[weekIdx].value = aspValue !== 0 ? Math.round(salesValue / aspValue) : 0;
            product.quarters[quarterIdx].weeks[weekIdx].isChanged = true;
            product.quarters[quarterIdx].isChanged = true;
          });
        this.state.dataSource.rows[planUnitIdx].products.forEach((product) => {
          product.quarters.forEach((quarter) => {
            quarter.value = calculateHorizontalWeekTotal(quarter.weeks, measureGroup);
          });
        });
        this.state.dataSource.rows[planUnitIdx].products.forEach((product) => {
          product.value = calculateEachProductTotal(product.quarters, measureGroup);
        });
      }
    }

    if (measureGroup === 'Plan ASP' && productName !== 'Average') {
      const planUnitIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - UNITS');
      const planValueIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - $');
      const planMarginIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Margin $');

      const planQuotaValue = this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value;
      const planUnitValue = this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value;

      this.state.dataSource.rows[rowIdx].products[productIdx].quarters[quarterIdx].isChanged = false;
      this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].isChanged = true;
      this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].isChanged = true;
      this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;

      /*Update week, quarter and measure value of Plan ASP*/
      const avgIdx = this.state.dataSource.rows[rowIdx].products.findIndex((product) => product.name === 'Average');
      const marginTotalIdx = this.state.dataSource.rows[planMarginIdx].products.findIndex((product) => product.name === 'Total');
      /*
      this.state.dataSource.rows[rowIdx].products[avgIdx].quarters[quarterIdx].weeks[weekIdx].value =
        calculateWeekTotalForEachMeasure(rowArr, rowIdx, productIdx, quarterIdx, weekIdx, measureGroup);
      this.state.dataSource.rows[rowIdx].products[avgIdx].quarters[quarterIdx].value =
        calculateQuarterValue(rowArr, rowIdx, productIdx, quarterIdx, measureGroup);
      this.state.dataSource.rows[rowIdx].products[avgIdx].value =
        calculateProductTotal(rowArr, rowIdx, productIdx, measureGroup);
      */
      const totalIdx = this.state.dataSource.rows[planUnitIdx].products.findIndex((product) => product.name === 'Total');
      const salestotalIdx = this.state.dataSource.rows[planValueIdx].products.findIndex((product) => product.name === 'Total');

      /*edit control for dependent measures*/
      this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;

      this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].weeks.forEach((week) => {
        week.isDisabled = true;
      });
      this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].weeks.forEach((week) => {
        week.isDisabled = true;
      });
      this.state.dataSource.rows[rowIdx].products[avgIdx].quarters[quarterIdx].weeks.forEach((week) => {
        week.isDisabled = true;
      });

      const isPlanValueEdited = this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isEdited;
      const isPlanUnitEdited = this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isEdited;

      if (isPlanValueEdited) {
        /*Calculation of UNIT when ASP and Plan Quota are edited*/
        const planValue = this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value;
        this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value =
          value !== 0 ? Math.round(planValue / value) : 0;

        /*Calculation of UNIT total when ASP and Plan Quota are edited*/
        const totalIdx = this.state.dataSource.rows[planValueIdx].products.findIndex((product) => product.name === 'Total');
        const planValueTotal = this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value;
        const planAspTotal = this.state.dataSource.rows[rowIdx].products[avgIdx].quarters[quarterIdx].weeks[weekIdx].value;

        this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value =
          planAspTotal !== 0 ? Math.round(planValueTotal / planAspTotal) : 0;
        this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value =
          calculateVerticalWeekTotal(this.state.dataSource.rows[planUnitIdx].products, quarterIdx, weekIdx, 'Plan / Quota - UNITS');
        this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].value =
          calculateHorizontalWeekTotal(this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].weeks, 'Plan / Quota - UNITS');
        this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].value =
          calculateHorizontalWeekTotal(this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].weeks, 'Plan / Quota - UNITS');

        this.state.dataSource.rows[planUnitIdx].products[totalIdx].value =
          calculateMeasureTotal(this.state.dataSource.rows[planUnitIdx].products, 'Plan / Quota - UNITS');
        this.state.dataSource.rows[planUnitIdx].products.forEach((product) => {
          product.value = calculateEachProductTotal(product.quarters, 'Plan / Quota - UNITS');
        });

        this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;
      } else if (isPlanUnitEdited) {
        /*Calculation of Plan Quota when ASP and UNIT are edited*/
        const totalIdx = this.state.dataSource.rows[planValueIdx].products.findIndex((product) => product.name === 'Total');
        const planUnitValue = this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value;
        this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value =
          TwoDecimalPlace(planUnitValue * value);

        /*Calculation of Plan Quota total when ASP and UNIT are edited*/
        this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value =
          calculateVerticalWeekTotal(this.state.dataSource.rows[planValueIdx].products, quarterIdx, weekIdx, measureGroup);
        this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].value =
          calculateHorizontalWeekTotal(this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks, measureGroup);
        this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].value =
          calculateHorizontalWeekTotal(this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].weeks, measureGroup);

        this.state.dataSource.rows[planValueIdx].products[totalIdx].value =
          calculateMeasureTotal(this.state.dataSource.rows[planValueIdx].products, measureGroup);
        this.state.dataSource.rows[planValueIdx].products.forEach((product) => {
          product.value = calculateEachProductTotal(product.quarters, measureGroup);
        });

        this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;
      } else {

        //Calculate Margin % for Each Product from old Margin $ and old Sales Value
        const oldMarginValue = this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].oldVal;
        const oldSalesValue = this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].oldVal;
        const oldMarginPctValue = (oldMarginValue / oldSalesValue) * 100;

        this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value =
          planUnitValue != 0 ? TwoDecimalPlace(planUnitValue * value) : 0;
        // this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;

        this.state.dataSource.rows[planValueIdx].products[salestotalIdx].quarters[quarterIdx].weeks[weekIdx].value =
          calculateVerticalWeekTotal(this.state.dataSource.rows[planValueIdx].products, quarterIdx, weekIdx, 'Plan / Quota - $');
        this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].value =
          calculateHorizontalWeekTotal(this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks, 'Plan / Quota - $');
        this.state.dataSource.rows[planValueIdx].products[salestotalIdx].quarters[quarterIdx].value =
          calculateHorizontalWeekTotal(this.state.dataSource.rows[planValueIdx].products[salestotalIdx].quarters[quarterIdx].weeks, 'Plan / Quota - $');

        this.state.dataSource.rows[planValueIdx].products[salestotalIdx].value =
          calculateMeasureTotal(this.state.dataSource.rows[rowIdx].products, 'Plan / Quota - $');
        this.state.dataSource.rows[planValueIdx].products.forEach((product) => {
          product.value = calculateEachProductTotal(product.quarters, 'Plan / Quota - $');
        });

        this.state.dataSource.rows[rowIdx].products[productIdx].quarters[quarterIdx].value =
          TwoDecimalPlace(
            this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].value /
            this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].value
          );

        this.state.dataSource.rows[rowIdx].products[avgIdx].quarters[quarterIdx].value =
          TwoDecimalPlace(
            this.state.dataSource.rows[planValueIdx].products[salestotalIdx].quarters[quarterIdx].value /
            this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].value
          );

        this.state.dataSource.rows[rowIdx].products[productIdx].value =
          TwoDecimalPlace(
            this.state.dataSource.rows[planValueIdx].products[productIdx].value /
            this.state.dataSource.rows[planUnitIdx].products[productIdx].value
          );

        this.state.dataSource.rows[rowIdx].products[avgIdx].value =
          TwoDecimalPlace(
            this.state.dataSource.rows[planValueIdx].products[salestotalIdx].value /
            this.state.dataSource.rows[planUnitIdx].products[totalIdx].value
          );

        //Caluclate Margin $ Value
        const newSalesPlanValue = this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value;
        this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value =
          TwoDecimalPlace(newSalesPlanValue * (oldMarginPctValue / 100));
        this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].isChanged = true;
        this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
        this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;

        this.state.dataSource.rows[planMarginIdx].products[marginTotalIdx].quarters[quarterIdx].weeks[weekIdx].value =
          calculateVerticalWeekTotal(this.state.dataSource.rows[planMarginIdx].products, quarterIdx, weekIdx, 'Margin $');
        this.state.dataSource.rows[planMarginIdx].products[marginTotalIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;

        this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].value =
          calculateHorizontalWeekTotal(this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].weeks, 'Margin $');
        this.state.dataSource.rows[planMarginIdx].products[marginTotalIdx].quarters[quarterIdx].value =
          calculateHorizontalWeekTotal(this.state.dataSource.rows[planMarginIdx].products[marginTotalIdx].quarters[quarterIdx].weeks, 'Margin $');

        this.state.dataSource.rows[planMarginIdx].products.forEach((product) => {
          product.value = calculateEachProductTotal(product.quarters, 'Margin $');
        });
      }
    }

    if (measureGroup === 'Plan ASP' && productName === 'Average') {
      const planUnitIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - UNITS');
      const planValueIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - $');
      const planMarginIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Margin $');

      const planQuotaValue = this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value;
      const planUnitValue = this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value;

      this.state.dataSource.rows[rowIdx].products[productIdx].quarters[quarterIdx].isChanged = false;
      /*
      this.state.dataSource.rows[rowIdx].products.forEach((product) => {
        product.quarters.forEach((quarter) => {
          quarter.value = calculateHorizontalWeekTotal(quarter.weeks, measureGroup);
        });
      });
      this.state.dataSource.rows[rowIdx].products.forEach((product) => {
        product.value = calculateEachProductTotal(product.quarters, measureGroup);
      });*/

      /*Update week, quarter and measure value of Plan ASP*/
      const planAspIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan ASP');
      const totalIdx = this.state.dataSource.rows[planUnitIdx].products.findIndex((product) => product.name === 'Total');
      const avgIdx = this.state.dataSource.rows[planAspIdx].products.findIndex((product) => product.name === 'Average');

      /*  this.state.dataSource.rows[planAspIdx].products
          .filter((product) => product.name !== 'Average')
          .forEach((product) => {
            product.quarters[quarterIdx].weeks[weekIdx].value =
              TwoDecimalPlace(
                (product.quarters[quarterIdx].weeks[weekIdx].oldVal /
                  this.state.dataSource.rows[planAspIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].oldVal)
                * value
              );
            product.quarters[quarterIdx].weeks[weekIdx].isChanged = true;
          });
        this.state.dataSource.rows[planAspIdx].products.forEach((product, pIdx: number) => {
          product.quarters.forEach((quarter, qIdx: number) => {
            quarter.value = calculateQuarterValue(rowArr, planAspIdx, pIdx, qIdx, 'Plan ASP');
          });
        });
        this.state.dataSource.rows[planAspIdx].products.forEach((product, pIdx: number) => {
          product.value = calculateProductTotal(rowArr, planAspIdx, pIdx, 'Plan ASP');
        });
  */
      /*edit control for dependent measures*/
      this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;

      this.state.dataSource.rows[planUnitIdx].products
        .filter((product, pIdx: number) => this.state.dataSource.rows[planUnitIdx].products.length - 1 !== pIdx)
        .forEach((product) => {
          product.quarters[quarterIdx].weeks.forEach((week) => {
            week.isDisabled = true;
          });
        });
      this.state.dataSource.rows[planValueIdx].products
        .filter((product, pIdx: number) => this.state.dataSource.rows[planValueIdx].products.length - 1 !== pIdx)
        .forEach((product) => {
          product.quarters[quarterIdx].weeks.forEach((week) => {
            week.isDisabled = true;
          });
        });
      this.state.dataSource.rows[rowIdx].products
        .filter((product, pIdx: number) => this.state.dataSource.rows[rowIdx].products.length - 1 !== pIdx)
        .forEach((product) => {
          product.quarters[quarterIdx].weeks.forEach((week) => {
            week.isDisabled = true;
          });
        });

      const isPlanValueEdited = this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].isEdited;
      const isPlanUnitEdited = this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].isEdited;

      if (isPlanValueEdited) {
        const planValueWeekTotal = this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value;
        this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value =
          value !== 0 ? Math.round(planValueWeekTotal / value) : 0;

        this.state.dataSource.rows[planUnitIdx].products
          .filter((product) => product.name !== 'Total')
          .forEach((product, pIdx) => {

            //Calulate Margin % for Each Product from old Margin $ and old Sales Value
            const oldMarginValue = this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].weeks[weekIdx].oldVal;
            const oldSalesValue = product.quarters[quarterIdx].weeks[weekIdx].oldVal;
            const oldMarginPctValue = (oldMarginValue / oldSalesValue) * 100;

            //Calulate Sales Value
            product.quarters[quarterIdx].weeks[weekIdx].value =
              TwoDecimalPlace(
                (product.quarters[quarterIdx].weeks[weekIdx].oldVal /
                  this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].oldVal)
                * Math.round(planValueWeekTotal / value)
              );
            product.quarters[quarterIdx].weeks[weekIdx].isChanged = true;
            product.quarters[quarterIdx].isChanged = true;

            //Calculate Margin $
            const newSalesValue = product.quarters[quarterIdx].weeks[weekIdx].value;
            this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].weeks[weekIdx].value = TwoDecimalPlace(newSalesValue * (oldMarginPctValue / 100));
            this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
            this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].isChanged = true;
            this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;

          });
        this.state.dataSource.rows[planUnitIdx].products.forEach((product) => {
          product.quarters.forEach((quarter) => {
            quarter.value = calculateHorizontalWeekTotal(quarter.weeks, 'Plan / Quota - UNITS');
          });
        });
        this.state.dataSource.rows[planUnitIdx].products.forEach((product) => {
          product.value = calculateEachProductTotal(product.quarters, 'Plan / Quota - UNITS');
        });

        this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;
      } else if (isPlanUnitEdited) {
        const planUnitValue = this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value;
        this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value =
          TwoDecimalPlace(planUnitValue * value);

        this.state.dataSource.rows[planValueIdx].products
          .filter((product) => product.name !== 'Total')
          .forEach((product) => {
            product.quarters[quarterIdx].weeks[weekIdx].value =
              TwoDecimalPlace(
                (product.quarters[quarterIdx].weeks[weekIdx].oldVal /
                  this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].oldVal)
                * TwoDecimalPlace(planUnitValue * value)
              );
            product.quarters[quarterIdx].weeks[weekIdx].isChanged = true;
            product.quarters[quarterIdx].isChanged = true;
          });
        this.state.dataSource.rows[planValueIdx].products.forEach((product) => {
          product.quarters.forEach((quarter) => {
            quarter.value = calculateHorizontalWeekTotal(quarter.weeks, 'Plan / Quota - $');
          });
        });
        this.state.dataSource.rows[planValueIdx].products.forEach((product) => {
          product.value = calculateEachProductTotal(product.quarters, 'Plan / Quota - $');
        });

        this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;
      } else {
        this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value =
          TwoDecimalPlace(planUnitValue * value);

        this.state.dataSource.rows[planValueIdx].products
          .filter((product) => product.name !== 'Total')
          .forEach((product, pIdx) => {

            //Calulate Margin % for Each Product from old Margin $ and old Sales Value
            const oldMarginValue = this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].weeks[weekIdx].oldVal;
            const oldSalesValue = product.quarters[quarterIdx].weeks[weekIdx].oldVal;
            const oldMarginPctValue = (oldMarginValue / oldSalesValue) * 100;

            product.quarters[quarterIdx].weeks[weekIdx].value =
              TwoDecimalPlace(
                (product.quarters[quarterIdx].weeks[weekIdx].oldVal /
                  this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].oldVal)
                * this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value
              );
            product.quarters[quarterIdx].weeks[weekIdx].isChanged = true;
            product.quarters[quarterIdx].isChanged = true;

            //Calculate Margin $
            const newSalesValue = product.quarters[quarterIdx].weeks[weekIdx].value;
            this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].weeks[weekIdx].value = TwoDecimalPlace(newSalesValue * (oldMarginPctValue / 100));
            this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].isChanged = true;
            this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
            this.state.dataSource.rows[planMarginIdx].products[pIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;

          });

        this.state.dataSource.rows[planValueIdx].products
          .filter((product) => product.name !== 'Total')
          .forEach((product) => {
            product.quarters[quarterIdx].weeks[weekIdx].isChanged = true;
            product.quarters[quarterIdx].isChanged = true;
          });

        this.state.dataSource.rows[planValueIdx].products.forEach((product) => {
          product.quarters.forEach((quarter) => {
            quarter.value = calculateHorizontalWeekTotal(quarter.weeks, measureGroup);
          });
        });

        this.state.dataSource.rows[planValueIdx].products.forEach((product) => {
          product.value = calculateEachProductTotal(product.quarters, measureGroup);
        });


        // Calculate Average of each week
        this.state.dataSource.rows[rowIdx].products
          .filter((product) => product.name !== 'Total')
          .forEach((product) => {
            this.state.dataSource.rows[planValueIdx].products
              .filter((valproduct) => valproduct.name == product.name)
              .forEach((valproduct) => {
                this.state.dataSource.rows[planUnitIdx].products
                  .filter((unitproduct) => unitproduct.name == product.name)
                  .forEach((unitproduct) => {
                    const qValue = valproduct.quarters[quarterIdx].weeks[weekIdx].value;
                    const qUnit = unitproduct.quarters[quarterIdx].weeks[weekIdx].value;
                    product.quarters[quarterIdx].weeks[weekIdx].value = qUnit !== 0 ? TwoDecimalPlace(qValue / qUnit) : 0;

                  });

              });

          });

        this.state.dataSource.rows[rowIdx].products[avgIdx].quarters[quarterIdx].value =
          TwoDecimalPlace(
            this.state.dataSource.rows[planValueIdx].products[totalIdx].quarters[quarterIdx].value /
            this.state.dataSource.rows[planUnitIdx].products[totalIdx].quarters[quarterIdx].value
          );

        this.state.dataSource.rows[rowIdx].products[productIdx].value =
          TwoDecimalPlace(
            this.state.dataSource.rows[planValueIdx].products[productIdx].value /
            this.state.dataSource.rows[planUnitIdx].products[productIdx].value
          );

        this.state.dataSource.rows[planMarginIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value =
          calculateVerticalWeekTotal(this.state.dataSource.rows[planMarginIdx].products, quarterIdx, weekIdx, 'Margin $');

        this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].value =
          calculateHorizontalWeekTotal(this.state.dataSource.rows[planMarginIdx].products[productIdx].quarters[quarterIdx].weeks, 'Margin $');

        this.state.dataSource.rows[planMarginIdx].products.forEach((product) => {
          product.quarters
            .filter((quarter) => !quarter.isPast)
            .forEach((quarter) => {
              quarter.value = calculateHorizontalWeekTotal(quarter.weeks, 'Margin $');
            });
        });

        this.state.dataSource.rows[planMarginIdx].products.forEach((product, pIdx: number) => {
          product.value = calculateProductTotal(rowArr, planMarginIdx, pIdx, 'Margin $');
        });


      }
    }

    if (measureGroup === 'Margin %' && productName !== 'Average') {
      const marginValueIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Margin $');
      const planValueIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - $');
      const planUnitIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - UNITS');
      const planQuotaValue = this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value;

      this.state.dataSource.rows[rowIdx].products[productIdx].quarters[quarterIdx].isChanged = false;
      this.state.dataSource.rows[marginValueIdx].products[productIdx].quarters[quarterIdx].isChanged = true;
      this.state.dataSource.rows[marginValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      this.state.dataSource.rows[marginValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value =
        TwoDecimalPlace((planQuotaValue * value) / 100);
// Send plan unit and Sales while editing margin %
        this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].isChanged = true;
        this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
        this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].isChanged = true;
        this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;

      const totalIdx = this.state.dataSource.rows[marginValueIdx].products.findIndex((product) => product.name === 'Total');
      this.state.dataSource.rows[marginValueIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value =
        calculateVerticalWeekTotal(this.state.dataSource.rows[marginValueIdx].products, quarterIdx, weekIdx, measureGroup);
      this.state.dataSource.rows[marginValueIdx].products[productIdx].quarters[quarterIdx].value =
        calculateHorizontalWeekTotal(this.state.dataSource.rows[marginValueIdx].products[productIdx].quarters[quarterIdx].weeks, measureGroup);
      this.state.dataSource.rows[marginValueIdx].products[totalIdx].quarters[quarterIdx].value =
        calculateHorizontalWeekTotal(this.state.dataSource.rows[marginValueIdx].products[totalIdx].quarters[quarterIdx].weeks, measureGroup);

      this.state.dataSource.rows[marginValueIdx].products[totalIdx].value =
        calculateMeasureTotal(this.state.dataSource.rows[rowIdx].products, measureGroup);
      this.state.dataSource.rows[marginValueIdx].products.forEach((product) => {
        product.value = calculateEachProductTotal(product.quarters, measureGroup);
      });

      /*Update week, quarter and measure value of Margin %*/
      const avgIdx = this.state.dataSource.rows[rowIdx].products.findIndex((product) => product.name === 'Average');

      this.state.dataSource.rows[rowIdx].products[avgIdx].quarters[quarterIdx].weeks[weekIdx].value =
        calculateWeekTotalForEachMeasure(rowArr, rowIdx, productIdx, quarterIdx, weekIdx, measureGroup);
      this.state.dataSource.rows[rowIdx].products[avgIdx].quarters[quarterIdx].value =
        calculateQuarterValue(rowArr, rowIdx, productIdx, quarterIdx, measureGroup);
      this.state.dataSource.rows[rowIdx].products[avgIdx].value =
        calculateProductTotal(rowArr, rowIdx, productIdx, measureGroup);

      this.state.dataSource.rows[marginValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;
    }

    if (measureGroup === 'Margin %' && productName === 'Average') {
      const marginValueIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Margin $');
      const planValueIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - $');
      const planQuotaValue = this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value;

      this.state.dataSource.rows[rowIdx].products[productIdx].quarters[quarterIdx].isChanged = false;

      const totalIdx = this.state.dataSource.rows[marginValueIdx].products.findIndex((product) => product.name === 'Total');
      this.state.dataSource.rows[marginValueIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value =
        TwoDecimalPlace((planQuotaValue * value) / 100);

      this.state.dataSource.rows[marginValueIdx].products
        .filter((product) => product.name !== 'Total')
        .forEach((product) => {
          product.quarters[quarterIdx].weeks[weekIdx].value =
            TwoDecimalPlace(
              (product.quarters[quarterIdx].weeks[weekIdx].oldVal /
                this.state.dataSource.rows[marginValueIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].oldVal)
              * this.state.dataSource.rows[marginValueIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value
            );
          product.quarters[quarterIdx].weeks[weekIdx].isChanged = true;
          product.quarters[quarterIdx].isChanged = true;
        });
      this.state.dataSource.rows[rowIdx].products.forEach((product) => {
        product.quarters.forEach((quarter) => {
          quarter.value = calculateHorizontalWeekTotal(quarter.weeks, measureGroup);
        });
      });
      this.state.dataSource.rows[rowIdx].products.forEach((product) => {
        product.value = calculateEachProductTotal(product.quarters, measureGroup);
      });

      /*Update week, quarter and measure value of Margin %*/
      this.state.dataSource.rows[rowIdx].products
        .filter((product) => product.name !== 'Average')
        .forEach((product) => {
          product.quarters[quarterIdx].weeks[weekIdx].value =
            TwoDecimalPlace(
              (product.quarters[quarterIdx].weeks[weekIdx].oldVal /
                this.state.dataSource.rows[rowIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].oldVal)
              * value
            );
          product.quarters[quarterIdx].weeks[weekIdx].isChanged = true;
        });
      this.state.dataSource.rows[rowIdx].products.forEach((product, pIdx: number) => {
        product.quarters.forEach((quarter, qIdx: number) => {
          quarter.value = calculateQuarterValue(rowArr, rowIdx, pIdx, qIdx, 'Plan ASP');
        });
      });
      this.state.dataSource.rows[rowIdx].products.forEach((product, pIdx: number) => {
        product.value = calculateProductTotal(rowArr, rowIdx, pIdx, 'Plan ASP');
      });
    }

    if (measureGroup === 'Margin $' && productName !== 'Total') {
      const totalIdx = this.state.dataSource.rows[rowIdx].products.findIndex((product) => product.name === 'Total');
      const marginPctIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Margin %');
      const planValueIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - $');
      const planUnitIdx = this.state.dataSource.rows.findIndex((row) => row.name === 'Plan / Quota - UNITS');
      
      const planQuotaValue = this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value;
      this.state.dataSource.rows[marginPctIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].value =
      TwoDecimalPlace((value/planQuotaValue)*100);

      this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].isChanged = true;
      this.state.dataSource.rows[planValueIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].isChanged = true;
      this.state.dataSource.rows[planUnitIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;

      /*Update week, quarter and measure value of Margin $*/
      this.state.dataSource.rows[rowIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].value =
        calculateVerticalWeekTotal(this.state.dataSource.rows[rowIdx].products, quarterIdx, weekIdx, measureGroup);
      this.state.dataSource.rows[rowIdx].products[productIdx].quarters[quarterIdx].value =
        calculateHorizontalWeekTotal(this.state.dataSource.rows[rowIdx].products[productIdx].quarters[quarterIdx].weeks, measureGroup);
      this.state.dataSource.rows[rowIdx].products[totalIdx].quarters[quarterIdx].value =
        calculateHorizontalWeekTotal(this.state.dataSource.rows[rowIdx].products[totalIdx].quarters[quarterIdx].weeks, measureGroup);

      this.state.dataSource.rows[rowIdx].products[totalIdx].value =
        calculateMeasureTotal(this.state.dataSource.rows[rowIdx].products, measureGroup);
      this.state.dataSource.rows[rowIdx].products.forEach((product) => {
        product.value = calculateEachProductTotal(product.quarters, measureGroup);
      });

      this.state.dataSource.rows[marginPctIdx].products[productIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;
    }

    if (measureGroup === 'Margin $' && productName === 'Total') {
      /*Update week, quarter and measure value of Margin $*/
      const totalIdx = this.state.dataSource.rows[rowIdx].products.findIndex((product) => product.name === 'Total');

      this.state.dataSource.rows[rowIdx].products
        .filter((product) => product.name !== 'Total')
        .forEach((product) => {
          product.quarters[quarterIdx].weeks[weekIdx].value =
            TwoDecimalPlace(
              (product.quarters[quarterIdx].weeks[weekIdx].oldVal /
                this.state.dataSource.rows[rowIdx].products[totalIdx].quarters[quarterIdx].weeks[weekIdx].oldVal)
              * value
            );
          product.quarters[quarterIdx].weeks[weekIdx].isChanged = true;
          product.quarters[quarterIdx].isChanged = true;
        });
      this.state.dataSource.rows[rowIdx].products.forEach((product) => {
        product.quarters.forEach((quarter) => {
          quarter.value = calculateHorizontalWeekTotal(quarter.weeks, measureGroup);
        });
      });
      this.state.dataSource.rows[rowIdx].products.forEach((product) => {
        product.value = calculateEachProductTotal(product.quarters, measureGroup);
      });
    }

    this.props.UpdateEditRestriction(true);
    this.setState({ dataSource: this.state.dataSource });
  }

  updateEditAllData(isFreezeRequired: boolean): void {
    const payload: IEditAllPayload = { row: [] };

    const isQuarterExpanded = !!this.state.dataSource.rows
      .filter((row) => !!row.products
        .filter((product) => !!product.quarters
          .filter((quarter) => quarter.isExpanded).length).length).length;

    payload.row = this.state.dataSource.rows
      .filter((row) => row.products
        .filter((product) => !!product.quarters
          .filter((quarter) => quarter.isChanged).length).length)
      .map((row) => {
        return {
          name: row.name,
          products: row.products
            .filter((product) => ['Total', 'Average'].indexOf(product.name) === -1)
            .filter((product) => !!product.quarters
              .filter((quarter) => quarter.isChanged).length)
            .map((product) => {
              return {
                name: product.name,
                quarters: product.quarters
                  .filter((quarter) => quarter.isChanged)
                  .map((quarter) => {
                    const weekLength = quarter.weeks.length;
                    const isValidForecast = quarter.weeks[weekLength - 1].forecastVal > 0;

                    const quarterPayload: any = {
                      name: quarter.name,
                      ratioSelection: getRatioSelectionOfEditAllQuarterGrid(quarter),
                      ratioTotal: getRatioTotalForQuarter(quarter, getRatioSelectionOfEditAllQuarterGrid(quarter)),
                    };
                    if (isQuarterExpanded) {
                      quarterPayload.weeks = quarter.weeks
                        .filter((week) => week.isChanged)
                        .map((week) => {
                          return {
                            name: week.name,
                            value: week.value,
                            ratioSelection: getRatioSelectionOfEditAllGrid(week, isValidForecast),
                            ratioTotal: getRatioTotal(week, getRatioSelectionOfEditAllGrid(week, isValidForecast)),
                          };
                        });
                    } else {
                      quarterPayload.value = (quarter.value - nonEditableWeekTotal(quarter)) || 0
                    }
                    return quarterPayload;
                  })
              };
            })
        };
      });

    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname)
    };

    this.props.onUpdateStart();

    UpdateEditAllData(payload, params)
      .then((res) => {
        if (!!res && res != 'running') {
          if (isFreezeRequired) {
            this.freezePlan();
          } else {
            this.props.onUpdateEnd();
            this.props.UpdateEditRestriction(false);
          }
        } else if (res === 'running') {
          this.setState({ isRunningModal: true,
                      successMessage: 'Another user using same filters for saving, Please try after sometime.'
                     });
          this.props.onLoadEnd();
          this.props.onRunningEnd();
          this.dataInit(false);
          this.props.UpdateEditRestriction(false);
        }
      });
  }

  saveButtonValidity(): boolean {
    const { rows } = this.state.dataSource;

    const isTotalEdited = rows
      .reduce((rInit, row) =>
        rInit || row.products.reduce((pInit, p) =>
        pInit || p.isEdited, false), false);
    const isQuarterEdited = rows
      .reduce((rInit, row) =>
        rInit || row.products.reduce((pInit, p) =>
        pInit || !!p.quarters.reduce((qInit, q) =>
        qInit || q.isEdited, false), false), false);
    const isWeekEdited = rows
      .reduce((rInit, row) =>
        rInit || row.products.reduce((pInit, p) =>
        pInit || !!p.quarters.reduce((qInit, q) =>
        qInit || q.weeks.reduce((wInit, w) =>
        wInit || w.isEdited, false), false), false), false);
    return rows.length > 0 &&
      (isTotalEdited || isQuarterEdited || isWeekEdited);
  }

  saveFreezeButtonValidity(): boolean {
    const { rows } = this.state.dataSource;

    if (rows.length === 0) {
      return false;
    }

    const unitIdx = rows.findIndex((row) => row.name === 'Plan / Quota - UNITS');
    const total = calculateMeasureTotal(rows[unitIdx].products, 'Plan / Quota - UNITS');

    return total > 0;
  }

  disableActionBtn(): boolean {
    const { rows } = this.state.originalDataSource;

    if (!rows?.length || !rows[0]?.products?.length) {
      return true;
    }

    return rows[0].products[0].quarters.some(q => q.isPast);
  }

  render(): React.ReactNode {
    if (this.state.isLoading) {
      return null;
    }

    if (this.state.isAutoLoad) {
      return <InitialMessage/>;
    }

    if (this.state.originalDataSource.rows.length === 0) {
      return <NoDataFound/>;
    }

    if (!this.validateJSON()) {
      return <InvalidData/>;
    }

    const renderEventInfo = (events, type: string) => (
      events.map((event, eventIdx) => (
        <React.Fragment key={eventIdx}>
          <p className="mb-1">Event Name: {event.eventName} ({type})</p>
          <p className="mb-1">Country: {event.countryCode}</p>
          <p className="mb-1">Start Date: {event.eventStartDate}</p>
          <p className="mb-0">End Date: {event.eventEndDate}</p>
          {events.length - 1 !== eventIdx && <hr className="my-2"/>}
        </React.Fragment>
      ))
    );

    const headerSection = <Card className="section-header-card">
      <Row>
        <Col md={7} className="align-self-center">

          <Row className="align-items-center">
            <Col md={6}>

              <div className="d-flex">
                <p className="table-title">{this.props.filterData.level} -
                  <span className="sub-title"> {this.props.filterData.products}</span>
                </p>
                <img src={InfoIcon} alt="info-icon" className="cursor-pointer"/>
              </div>

            </Col>

            <Col md={5}>

              <div className="custom-form-container">
                <label htmlFor="comparision-metrics" className="custom-form-label">Comparision metrics</label>
                <select
                  id="comparision-metrics"
                  className="custom-drop-down-field"
                  onChange={(e) => {
                    this.props.isAllowed
                      ? this.setState({ isEditRestrictionAllowed: true })
                      : this.setState({ isEditRestrictionAllowed: false });
                    this.setState({
                      comparisionMetrics: e.target.value === 'None' ? '' : e.target.value
                    }, () => {
                      this.dataInit(false);
                    });
                  }}
                >
                  {
                    this.state.comparisionMetricsList.map((data, idx) => (
                      <option
                        key={idx}
                        value={data.value}
                      >
                        {data.label}
                      </option>
                    ))
                  }
                </select>
              </div>

            </Col>
          </Row>

        </Col>

        <Col md={{ size: 2, offset: 3 }} className="align-self-center">

          <div className="d-flex justify-content-end">
            <Dropdown
              isOpen={this.state.isMoreMenuOpened}
              toggle={this.toggleMoreMenu}
              className="d-inline-block user-dropdown"
            >
              <Tooltip content={'More'} direction={'top'}>
                <DropdownToggle tag="button" className="btn action-btn waves-effect p-0">
                  <img src={MoreIcon} alt="more-icon"/>
                </DropdownToggle>
              </Tooltip>

              <DropdownMenu className="dropdown-menu-end">
                {/*<DropdownItem
                  onClick={() => {
                    this.freezePlan();
                    if (this.props.isAllowed) {
                      this.setState({ isEditRestrictionAllowed: true });
                    }
                  }}
                >Freeze Plan</DropdownItem>

                <DropdownItem divider/>*/}
                <Dropdown
                  isOpen={this.state.isDownloadMenu}
                  toggle={this.toggleDownloadMenu}
                  className="d-inline-block user-dropdown"
                  direction="end"
                >
                  <DropdownToggle className={styles['dropdown-toggle']}>Download Template</DropdownToggle>
                  <DropdownMenu id={styles['downloadDropdown']}>
                    <DropdownItem onClick={() => this.downloadEditAllTemplate('units', 'RSPEA')}>Units</DropdownItem>
                    <DropdownItem
                      onClick={() => this.downloadEditAllTemplate('revenue', 'RSPEA')}>Revenue</DropdownItem>
                  </DropdownMenu>
                </Dropdown>

                <DropdownItem divider/>

                <div className="position-relative">
                  <DropdownItem
                    disabled={this.disableActionBtn()}
                    onClick={() => {
                      if (this.props.isAllowed) {
                        this.setState({ isEditRestrictionAllowed: true });
                      }
                    }}
                  >
                    Import Edit All Template
                  </DropdownItem>
                  <input
                    type="file"
                    accept=".csv,
                      application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                      application/vnd.ms-excel"
                    disabled={this.disableActionBtn()}
                    onChange={(e) => {
                      this.importTemplateEditAll(e);
                      this.toggleMoreMenu();
                    }}
                  />
                </div>

              </DropdownMenu>
            </Dropdown>
          </div>
        </Col>
      </Row>
    </Card>;
    const bodySection = <div className="table-responsive table-outline custom-table sticky-table">
      <Table className="mb-0">
        <thead>
        <tr>
          <th className="dark-bg-cell"/>
          {
            this.state.dataSource.columns.map((col, colIdx: number) => (
              <th
                key={colIdx}
                colSpan={col.isExpanded ? totalWeeksOfSelectedQuarter(this.state.dataSource.columns, colIdx) : 1}
              >
                  <span
                    className="toggle-col"
                  >
                    {col.name}
                    {
                      !!col.months && col.months.length > 0 &&
                      <i
                        className={`${col.isExpanded ? 'ri-checkbox-indeterminate-fill' : 'ri-add-box-fill'} ms-sm-2`}
                        onClick={() => {
                          this.props.isAllowed
                            ? this.setState({ isEditRestrictionAllowed: true })
                            : this.onExpandColumn(colIdx, col.isExpanded);
                        }}
                      />
                    }
                  </span>
              </th>
            ))
          }
          <th
            className="table-header-text dark-bg-cell v-middle"
            style={{ whiteSpace: 'nowrap' }}
          >
            Grand Total
          </th>
        </tr>
        {
          this.isColumnExpanded() &&
          <React.Fragment>
            <tr>
              <th className="dark-bg-cell"/>
              {
                this.state.dataSource.columns.map((quarter, qIdx: number) => (
                  <React.Fragment key={qIdx}>
                    {
                      quarter.isExpanded
                        ? quarter.months.map((month, pIdx: number) => (
                          <th
                            key={pIdx}
                            colSpan={quarter.isExpanded ? month.weeks.length : 1}
                            className="text-center"
                          >
                            {month.name}
                          </th>
                        ))
                        : <th/>
                    }
                  </React.Fragment>
                ))
              }
              <th/>
              <th className="dark-bg-cell"/>
            </tr>
            <tr>
              <th className="dark-bg-cell"/>
              {
                this.state.dataSource.columns.map((quarter, qIdx: number) => (
                  <React.Fragment key={qIdx}>
                    {
                      quarter.isExpanded
                        ? quarter.months.map((month, pIdx: number) => (
                          <React.Fragment key={pIdx}>
                            {
                              quarter.isExpanded &&
                              month.weeks.map((week, wIdx: number) => (
                                <th
                                  key={wIdx}
                                  className="text-center"
                                >
                                  <div className="d-flex justify-content-between">
                                    <span>{week.name}</span>
                                    {
                                      (week.eventInfo?.MAIN?.length > 0 || week.eventInfo?.Other?.length > 0) &&
                                      (
                                        <Tooltip
                                          content={
                                            <React.Fragment>
                                              {week.eventInfo?.Other && renderEventInfo(week.eventInfo.Other, 'Other')}
                                              {week.eventInfo?.MAIN && renderEventInfo(week.eventInfo.MAIN, 'Main')}
                                            </React.Fragment>
                                          }
                                          style={{ textAlign: 'left', top: '30px' }}
                                        >
                                          <i className="mdi mdi-note cursor-pointer"/>
                                        </Tooltip>
                                      )
                                    }
                                  </div>
                                </th>
                              ))
                            }
                            {
                              quarter.months.length - 1 === pIdx &&
                              <th className="dark-bg-cell text-center">Total</th>
                            }
                          </React.Fragment>
                        ))
                        : <th/>
                    }
                  </React.Fragment>
                ))
              }
              <th className="dark-bg-cell"/>
            </tr>
          </React.Fragment>
        }
        </thead>

        <tbody>
        {
          this.state.dataSource.rows.map((row, rIdx: number) => (
            <React.Fragment key={rIdx}>
              <tr className="table-header-outline bg-white">
                <td className="table-header-text text-right">{row.displayName}</td>
                {
                  this.state.dataSource.columns.map((quarter, qIdx: number) => (
                    <React.Fragment key={qIdx}>
                      {
                        quarter.isExpanded
                          ? quarter.months.map((month, pIdx: number) => (
                            <React.Fragment key={pIdx}>
                              {
                                quarter.isExpanded &&
                                month.weeks.map((week, wIdx: number) => (
                                  <td key={wIdx}/>
                                ))
                              }
                              {
                                quarter.months.length - 1 === pIdx && <td className="dark-bg-cell"/>
                              }
                            </React.Fragment>
                          ))
                          : <td/>
                      }
                    </React.Fragment>
                  ))
                }
                <td className="dark-bg-cell"/>
              </tr>
              {
                row.products.map((product, pIdx) => (
                  <tr key={pIdx}>
                    <td className="table-data-text dark-bg-cell text-right">{product.name}</td>
                    <td className="text-right">{NumberWithCommas(product.LYLQ[0].value)}</td>
                    <td className="text-right">{(product.LYLQ[1].value) + "%"}</td>
                    {
                      product.quarters.map((quarter, qIdx) => (
                        <React.Fragment key={qIdx}>
                          {
                            !quarter.isExpanded
                              ? <td className={`${quarter.isPast ? 'disabled-cell' : ''} text-right`}>
                                {/*<span className={`${IsNegative(quarter.value) && 'text-danger'}`}>
                                  {product.datatype === 'currency' && '$'}
                                </span>*/}
                                {
                                  (!this.isColumnExpanded() && !quarter.isPast)
                                    ? <input
                                      type="number"
                                      className={
                                        `${(quarter.isEdited)
                                          ? 'editable-input-new'
                                          : 'editable-input'}
                                        ${quarter.isDisabled && ' readonly-input'}
                                        ${IsNegative(quarter.value) && ' error-input'}`
                                      }
                                      readOnly={quarter.isDisabled}
                                      onChange={(e) => {
                                        this.updateQuarterCalculation(this.state.dataSource.rows, rIdx, pIdx, qIdx, row.name, product.name, e);
                                      }}
                                      value={quarter.value}
                                    />
                                    : <span className={`${IsNegative(quarter.value) && 'text-danger'}`}>
                                        {NumberWithCommas(TwoDecimalPlace(quarter.value))}
                                      </span>
                                }
                                {/*<span className={`${IsNegative(quarter.value) && 'text-danger'}`}>
                                  {product.datatype === 'percentage' && '%'}
                                </span>*/}
                                {
                                  ['ly', 'lq'].indexOf(this.state.comparisionMetrics) !== -1 &&
                                  <React.Fragment>
                                    <span className="d-block text-success">
                                      {/*{product.datatype === 'currency' && '$'}*/}
                                      {quarter[this.state.comparisionMetrics]}
                                      {/*{product.datatype === 'percentage' && '%'}*/}
                                    </span>
                                  </React.Fragment>
                                }
                              </td>
                              : quarter.weeks.map((week, wIdx: number) => (
                                <React.Fragment key={wIdx}>
                                  <td className={`${week.isPast ? 'disabled-cell' : ''} text-right`}>
                                    {/*<span className={`${IsNegative(week.value) && 'text-danger'}`}>
                                      {product.datatype === 'currency' && '$'}
                                    </span>*/}
                                    {
                                      (this.isColumnExpanded() && !week.isPast)
                                        ? <input
                                          type="text"
                                          className={
                                            `${(week.isEdited)
                                              ? 'editable-input-new'
                                              : 'editable-input'}
                                            ${week.isDisabled && ' readonly-input'}
                                            ${IsNegative(week.value) && ' error-input'}`
                                          }
                                          readOnly={week.isDisabled}
                                          onChange={(e) => {
                                            this.updateWeekCalculation(this.state.dataSource.rows, rIdx, pIdx, qIdx, wIdx, row.name, product.name, e);
                                          }}
                                          value={week.value}
                                        />
                                        : <span className={`${IsNegative(week.value) && 'text-danger'}`}>
                                            {NumberWithCommas(TwoDecimalPlace(week.value))}
                                          </span>
                                    }
                                    {/*<span className={`${IsNegative(week.value) && 'text-danger'}`}>
                                      {product.datatype === 'percentage' && '%'}
                                    </span>*/}
                                    {
                                      ['ly', 'lq'].indexOf(this.state.comparisionMetrics) !== -1 &&
                                      <React.Fragment>
                                          <span className="d-block text-success">
                                            {/*{product.datatype === 'currency' && '$'}*/}
                                            {week[this.state.comparisionMetrics]}
                                            {/*{product.datatype === 'percentage' && '%'}*/}
                                          </span>
                                      </React.Fragment>
                                    }
                                  </td>
                                  {
                                    quarter.weeks.length - 1 === wIdx &&
                                    <td className="dark-bg-cell text-right">
                                        <span className={`${IsNegative(quarter.value) && 'text-danger'}`}>
                                          {/*{product.datatype === 'currency' && '$'}*/}
                                          {NumberWithCommas(TwoDecimalPlace(quarter.value || 0))}
                                          {/*{product.datatype === 'percentage' && '%'}*/}
                                        </span>
                                      {
                                        ['ly', 'lq'].indexOf(this.state.comparisionMetrics) !== -1 &&
                                        <React.Fragment>
                                            <span className="d-block text-success">
                                              {/*{product.datatype === 'currency' && '$'}*/}
                                              {quarter[this.state.comparisionMetrics]}
                                              {/*{product.datatype === 'percentage' && '%'}*/}
                                            </span>
                                        </React.Fragment>
                                      }
                                    </td>
                                  }
                                </React.Fragment>
                              ))
                          }
                        </React.Fragment>
                      ))
                    }
                    <td
                      className={`dark-bg-cell text-right`}
                    >
                      {/*<span className={`${IsNegative(product.value) && 'text-danger'}`}>
                        {product.datatype === 'currency' && '$'}
                      </span>*/}
                      {
                        (!this.isColumnExpanded() && !product.isPast)
                          ? <input
                            type="text"
                            className={
                              `${(product.isEdited)
                                ? 'editable-input-new'
                                : 'editable-input'}
                            ${product.isDisabled && ' readonly-input'}
                            ${IsNegative(product.value) && ' error-input'}`
                            }
                            readOnly={product.isDisabled}
                            onChange={(e) => {
                              this.updateMeasureCalculation(this.state.dataSource.rows, rIdx, pIdx, row.name, product.name, e);
                            }}
                            value={product.value}
                          />
                          : <span className={`${IsNegative(product.value) && 'text-danger'}`}>
                              {NumberWithCommas(TwoDecimalPlace(product.value || 0))}
                            </span>
                      }
                      {/*<span className={`${IsNegative(product.value) && 'text-danger'}`}>
                        {product.datatype === 'percentage' && '%'}
                      </span>*/}
                      {
                        ['ly', 'lq'].indexOf(this.state.comparisionMetrics) !== -1 &&
                        <React.Fragment>
                            <span className="d-block text-success">
                              {/*{product.datatype === 'currency' && '$'}*/}
                              {product[this.state.comparisionMetrics]}
                              {/*{product.datatype === 'percentage' && '%'}*/}
                            </span>
                        </React.Fragment>
                      }
                    </td>
                  </tr>
                ))
              }
            </React.Fragment>
          ))
        }
        </tbody>
      </Table>
    </div>;

    return (
      <React.Fragment>
        {headerSection}
        {bodySection}

        <ActionCard
          onCancel={() => {
            this.dataInit(false);
            this.props.UpdateEditRestriction(false);
          }}
          onSave={() => this.updateEditAllData(false)}
          onSaveAndFreeze={() => this.updateEditAllData(true)}
          isSaveDisabled={!this.saveButtonValidity()}
          isSaveAndFreezeDisabled={!this.saveFreezeButtonValidity()}
        />

        <UnsavedDataModal
          isOpen={this.state.isEditRestrictionAllowed}
          toggle={() => this.setState({ isEditRestrictionAllowed: !this.state.isEditRestrictionAllowed })}
          removeChanges={() => {
            this.props.UpdateEditRestriction(false);
            this.setState({
              dataSource: JSON.parse(JSON.stringify(this.state.originalDataSource)),
              isEditRestrictionAllowed: false
            });
          }}
        />

        <SuccessModal
          isOpen={this.state.isRunningModal}
          toggle={() => this.setState({ isRunningModal: !this.state.isRunningModal })}
          message={this.state.successMessage}
        />

      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any): StateProps => {
  return {
    ...state.EditRestriction,
    filterData: state.FilterData
  };
};

export default connect<StateProps, DispatchProps, OwnProps>
(mapStateToProps, {
  UpdateEditRestriction
})(withRouter(EditAllTable));
